export const landing4 = {
  navbar: {
    solutions: "Miért a Bespire?",
    useCases: "Kinek való?",
    howItWorks: "Hogyan működik",
    pricing: "Árak",
    faq: "GYIK",
    about: "Rólunk",
    whyBespireItems: [
      { label: "Márka és stratégia", subtitle: "Arculat, personák, üzleti terv, versenytárs-elemzés", icon: "Palette", href: "/brand-strategy" },
      { label: "Weboldal, tartalom, SEO", subtitle: "Weboldal percek alatt, blogposztok, fordítás, SEO", icon: "Globe", href: "/website-builder" },
      { label: "Foglalás és naptár", subtitle: "Online foglalás, emlékeztetők, csoportos órák — a naptárad magától megy", icon: "Calendar", href: "/booking-system" },
      { label: "Marketing és social", subtitle: "Kampányok, posztok, hirdetések, email marketing", icon: "Megaphone", href: "/marketing-automation" },
      { label: "Admin és pénzügy", subtitle: "Üzleti áttekintés, riportok, havi zárás, kapacitás- és költségterv — a fizetés a rendszerben", icon: "Wallet", href: "/admin-finance" },
      { label: "Ügyfélkapcsolat", subtitle: "Visszahívás, follow-up, kritika-kezelés, közösség", icon: "Users", href: "/customer-relations" },
      { label: "Folyamatos AI asszisztens", subtitle: "Napi brief, teendők, proaktív javaslatok, riportok", icon: "Bot", href: "/daily-assistant" },
    ],
    whyBespireCta: "Nézd meg az összes AI-képességet →",
    waitlistButton: "Indítsd el most – ingyen",
    callbackButton: "Kérek visszahívást",
    login: "Bejelentkezés",
    startNow: "Indítsd el most",
    startNowFree: "Indítsd el most – ingyen",
    callbackShort: "Hívjanak vissza",
    menuLabel: "Menü",
    personasGroups: {
      healthBeauty: "Egészség & szépség",
      coachingHealth: "Coaching & egészség",
    },
    notFoundProfession: "Nem találod a szakmád? — A Bespire bármilyen szolgáltatónak.",
    startNowArrow: "Indítsd el most →",
    callbackArrow: "Vagy kérj visszahívást →",
    personasCol1: [
      { label: "Jóga & Pilates oktatók", href: "/for/yoga-pilates-instructors" },
      { label: "Fitness & Személyi edzők", href: "/for/fitness-personal-trainers" },
      { label: "Kozmetikusok & Szalonok", href: "/for/beauticians-beauty-salons" },
      { label: "Masszőrök & Terapeuták", href: "/for/massage-therapists" },
      { label: "Fodrászok & Borbélyok", href: "/for/hairdressers-barbers" },
      { label: "Körmösök", href: "/for/nail-technicians" },
      { label: "Gyógytornászok", href: "/for/physiotherapists" },
    ],
    personasCol2: [
      { label: "Tanácsadók & Business Coachok", href: "/for/consultants-business-coaches" },
      { label: "Pszichológusok & Mentorok", href: "/for/psychologists-mentors" },
      { label: "Táplálkozási tanácsadók", href: "/for/nutritionists" },
      { label: "Terapeuták & Coachok", href: "/for/therapists-coaches" },
      { label: "Sport klubbok", href: "/for/sport-clubs" },
      { label: "Fotósok & Videósok", href: "/for/photographers-videographers" },
    ],
  },
  footer: {
    description: "A platform alkotóknak, vállalkozóknak és kisvállalkozásoknak, hogy könnyedén építsd fel digitális jelenléted és növeld bevételeid.",
    product: "Termék",
    websiteBuilder: "Weboldal Építő",
    bookingSystem: "Foglalási Rendszer",
    marketingAutomation: "Marketing Automatizálás",
    pricing: "Árazás",
    forWho: "Kinek való?",
    forWhoHealthBeauty: "Egészség & Szépség",
    forWhoCoachingHealth: "Coaching & Egészség",
    yogaPilates: "Jóga & Pilates Oktatók",
    fitnessTrainers: "Fitness & Személyi Edzők",
    beauticians: "Kozmetikusok & Szalonok",
    massageTherapists: "Masszőrök & Terapeuták",
    hairdressers: "Fodrászok & Borbélyok",
    nailTechnicians: "Körmösök",
    physiotherapists: "Gyógytornászok",
    consultants: "Tanácsadók & Coachok",
    psychologists: "Pszichológusok & Mentorok",
    nutritionists: "Táplálkozási tanácsadók",
    therapistsCoaches: "Terapeuták & Coachok",
    sportClubs: "Sport klubbok",
    photographers: "Fotósok & Videósok",
    contact: "Kapcsolat",
    location: "Budapest, Magyarország",
    allRightsReserved: "Minden jog fenntartva.",
    privacyPolicy: "Adatvédelmi Irányelvek",
    termsOfService: "Felhasználási Feltételek",
    cookiePolicy: "Cookie Szabályzat",
  },
  newsletter: {
    title: "Kérj ingyenes visszahívást",
    subtitle: "Add meg telefonszámod és 48 órán belül visszahívunk — teljesen ingyen, kötelezettség nélkül.",
    namePlaceholder: "Neved (pl. Kovács Anna)",
    phonePlaceholder: "Telefonszámod (pl. +36 30 123 4567)",
    selectProfession: "Válaszd ki a foglalkozásod",
    professions: {
      fitness: "Fitness & Személyi Edző",
      yoga: "Jóga & Pilates Oktató",
      physiotherapist: "Gyógytornász & Fizioterapeuta",
      sportsClub: "Sport Klub",
      consultant: "Tanácsadó & Business Coach",
      trainer: "Terapeuta & Coach",
      nutritionist: "Táplálkozási Tanácsadó",
      psychologist: "Pszichológus & Mentor",
      hairdresser: "Fodrász & Borbély",
      photographer: "Fotós & Videós",
      beautician: "Kozmetikus & Szépségszalon",
      massage: "Masszőr & Terapeuta",
      nail: "Körmös & Műkörömépítő",
      other: "Egyéb",
    },
    setupOption: {
      label: "Szeretnéd, hogy teljesen beüzemeljük az oldalad?",
      yes: "Igen, kérem a teljes beüzemelést (50.000 Ft + ÁFA, egyszeri díj)",
      no: "Nem, magam szeretném kezelni",
    },
    websiteStatus: {
      label: "Van már weboldalad?",
      hasWebsite: "Igen, van weboldalam",
      noWebsite: "Nem, most indulok",
      websitePlaceholder: "Add meg a weboldalad címét (pl. www.example.hu)",
    },
    submitButton: "Indítsd el most – ingyen",
    privacyNote: "Az adataidat bizalmasan kezeljük. A visszahívás teljesen ingyenes.",
    callbackNote: "48 órán belül visszahívunk munkanapokon.",
    freeBadge: "100% ingyenes",
  },
  loading: "Betöltés...",
  seo: {
    title: "Bespire - AI Asszisztens Szolgáltatóknak",
    description: "AI-vezérelt weboldal, időpontfoglaló és marketing automatizálás fodrászoknak, edzőknek, tanácsadóknak és szolgáltató vállalkozásoknak.",
    keywords: "AI asszisztens, időpontfoglaló rendszer, weboldal építés, marketing automatizálás, fodrász, fitness, jóga, szalon",
  },
  hero: {
    badge: "Teljes körű AI asszisztens szolgáltatóknak",
    title: "Nem csak weboldalt épít — az egész vállalkozásodban segít",
    subtitle: "Weboldal, foglalás, marketing, kampányok, elemzések, új termékek, csapatépítés — az AI asszisztensed minden nap dolgozik veled.",
    rotatingPrefix: "Minden egy helyen",
    rotatingSuffix: "",
    rotatingAudiences: ["jógaoktatóknak", "kozmetikusoknak", "tanácsadóknak", "edzőknek", "terapeutáknak", "influenszereknek"],
    description: "Profin mutatkozz be online, ügyfeleid 0-24 foglalhatnak, az AI pedig segít új ügyfeleket szerezni.",
    cta: "Regisztrálj ingyen",
    ctaSecondary: "Kérj visszahívást",
    microcopy: "3 napig ingyen kipróbálhatod · Nincs szükség a kártyádra · Bármikor lemondhatod",
    watchVideo: "Videó megtekintése",
    forWho: "Fodrászoknak, edzőknek, kozmetikusoknak és minden szolgáltató vállalkozásnak",
    trustIndicators: {
      setup: "10 perc beállítás",
      trial: "3 napos próba",
      noCard: "Nincs kártyaszükség",
    },
    floatingBadges: {
      newClients: "Ingyenes feliratkozás",
      aiActive: "Nincs kártyaszükség",
    },
    chat: {
      title: "Bespire AI Asszisztens",
      online: "Online",
      demoBadge: "Élő chat demó",
      messages: [
        {
          role: "assistant" as const,
          content: "Szia! 👋 Én vagyok a Bespire AI asszisztensed. Segítek felépíteni a weboldaladat percek alatt. Milyen vállalkozásod van?",
        },
        {
          role: "user" as const,
          content: "Személyi edző vagyok, és szeretnék egy profi weboldalt ahol foglalni tudnak az ügyfeleim.",
        },
        {
          role: "assistant" as const,
          content: "Szuper! Máris készítem a személyi edző weboldaladat. Ezeket állítom be neked:",
          list: [
            "✅ Foglalási rendszer – ügyfeleid 0-24 foglalhatnak",
            "✅ Szolgáltatások oldal – edzéscsomagjaid bemutatása",
            "✅ Bemutatkozás – profi megjelenés, rólad szóló szekció",
            "✅ Kapcsolat – automatikus visszaigazolás emailben",
          ],
        },
        {
          role: "user" as const,
          content: "Ez király! És az árazást is be tudom állítani?",
        },
        {
          role: "assistant" as const,
          content: "Természetesen! Az árazási csomagjaidat egyszerűen szerkesztheted. Kész is van az oldalad alapja – nézd meg az előnézetet! 🚀",
        },
      ],
    },
  },
  stats: {
    title: "Számokban a siker",
    subtitle: "Amit elértünk az ügyféleinkkel együtt",
    items: [
      { label: "Elégedett ügyfél" },
      { label: "Lekezelve időpont" },
      { label: "Időmegtakarítás" },
      { label: "Értékelés" },
    ],
  },
  comparison: {
    title: "Miért a Bespire?",
    subtitle: "Hasonlítsd össze más megoldásokkal",
    partial: "Részben",
    columns: {
      feature: "Funkció",
      bespire: "Bespire",
      traditional: "Hagyományos",
      wordpress: "WordPress",
      manual: "Saját fejlesztés",
    },
    cta: "Próbáld ki ingyen",
    features: [
      { name: "Weboldal készítés", bespire: true, traditional: "partial", wordpress: true, manual: false },
      { name: "Időpontfoglaló rendszer", bespire: true, traditional: false, wordpress: "partial", manual: false },
      { name: "Marketing automatizálás", bespire: true, traditional: false, wordpress: false, manual: false },
      { name: "AI asszisztens", bespire: true, traditional: false, wordpress: false, manual: false },
      { name: "Beállítási idő", bespire: "10 perc", traditional: "2-4 hét", wordpress: "1-2 nap", manual: "1-3 hónap" },
      { name: "Technikai tudás szükséges", bespire: false, traditional: "partial", wordpress: "partial", manual: true },
      { name: "Havi költség", bespire: "9.900 Ft", traditional: "50.000+ Ft", wordpress: "20.000+ Ft", manual: "100.000+ Ft" },
      { name: "Mobil alkalmazás", bespire: true, traditional: false, wordpress: false, manual: "partial" },
      { name: "Ügyfél támogatás", bespire: true, traditional: "partial", wordpress: "partial", manual: false },
    ],
  },
  pricing: {
    title: "Egyszerű, átlátható árazás",
    subtitle: "Válaszd ki a számodra megfelelő csomagot",
    heading: "Egyszerű árazás. Két út, egy ár.",
    subheading: "Nincsenek meglepetések. Bármikor lemondhatod.",
    diy: {
      title: "Csináld magad, AI segítséggel",
      price: "12 900 Ft",
      priceSuffix: " + ÁFA / hó",
      note: "3 napos teljes hozzáférés, ingyen kezdődik",
      features: [
        "Teljes weboldal AI asszisztenssel",
        "Időpontfoglaló rendszer és automatikus emlékeztetők",
        "Digitális termékek, kurzusok, bérletek értékesítése",
        "AI-generált marketing tartalmak",
        "Email marketing automatizálás",
        "Saját domain",
        "Korlátlan munkatárs",
        "AI a napi munkádhoz — a csomag részeként",
      ],
      cta: "Indítsd el most – ingyen",
      footnote: "Bankkártya nem szükséges · 10 perc alatt élő",
    },
    setup: {
      title: "Mi beüzemeljük helyetted",
      price: "50 000 Ft",
      priceSuffix: " + ÁFA",
      note: "egyszeri díj, utána 12 900 Ft + ÁFA / hó",
      features: [
        "Teljes oldal a te arculatoddal",
        "Termékek és szolgáltatások feltöltve",
        "Időpontfoglaló és fizetés beüzemelve",
        "Domain bekötés és technikai beállítások",
        "Induló marketing tartalmak",
        "SEO és Google beállítás",
        "Personal onboarding és betanítás",
        "Elégedettségi garancia",
      ],
      cta: "Kérek visszahívást",
      footnote: "Munkanapokon 48 órán belül felhívunk · ingyenes és kötelezettség nélküli",
    },
  },
  aiCreditExamples: {
    badge: "Miben segít az AI",
    title: "Így használhatod nap mint nap",
    subtitle: "Az AI-asszisztens minden funkciója a csomagod része — a napi feladatoktól a kampányidőszakokig.",
    legendSimple: "Napi",
    legendComplex: "Kampányidőszakban",
    examples: [
      {
        task: "Szöveges posztok, hírlevelek",
        credits: "Napi feladat",
        description: "Figyelemfelkeltő szöveges tartalom készítése social médiára, blogra vagy hírlevélbe.",
      },
      {
        task: "Instagram poszt képpel",
        credits: "Rendszeres",
        description: "Egyedi grafika és hozzá illő szöveg egy közösségi média poszthoz.",
      },
      {
        task: "Komplett weboldal",
        credits: "Nagyobb feladat",
        description: "Professzionális, többoldalas weboldal generálása a márkádhoz igazítva, képekkel és szövegekkel együtt.",
      },
    ],
  },
  aiCredits: {
    badge: "AI-asszisztens a csomagban",
    title: "AI a napi munkádhoz — a csomag részeként",
    subtitle: "Az AI-asszisztenst és az AI-generálást (szöveg, kép, weboldal) a havidíjad tartalmazza. Nincs külön AI-díj, nincs kreditszámlálás, nincs meglepetés — használd a napi üzleti munkádhoz.",
    whatIsTitle: "Mit jelent, hogy a csomag része?",
    whatIsDescription: "A csomagod díja tartalmazza az AI-asszisztens és az AI-generálás napi használatát a normál üzleti működéshez. Kampányidőszakban, nagyobb terhelésnél vagy extrém, automatizált használatnál extra kapacitás igényelhető.",
    usageExamples: [
      {
        title: "Weboldal generálás",
        description: "Professzionális weboldal készítése néhány kérdés megválaszolása után.",
      },
      {
        title: "Képek generálása",
        description: "Egyedi képek, grafikák készítése a márkádhoz.",
      },
      {
        title: "Marketing tartalmak",
        description: "Social média posztok, email kampányok automatikus írása.",
      },
      {
        title: "Üzleti javaslatok",
        description: "Személyre szabott növekedési tippek és elemzések.",
      },
    ],
    benefits: [
      {
        title: "Időmegtakarítás",
        description: "Amit órákig csinálnál, az AI percek alatt megoldja helyetted.",
        highlight: "",
      },
      {
        title: "Nincs szükség szakértelemre",
        description: "Nem kell designer vagy marketinges tudás — az AI mindent megcsinál helyetted.",
      },
      {
        title: "AI a napi munkádhoz",
        description: "Nincs külön AI-díj, nincs kreditszámlálás. Használd a csomagod keretei között, amikor és amire szükséged van.",
      },
      {
        title: "Egyszerű, átlátható árazás",
        description: "Fix havidíj — nincsenek meglepetés-költségek, nincs extra kiegészítő.",
      },
    ],
    freeCredits: {
      title: "3 napos ingyenes próba",
      description: "3 napig teljes hozzáférést kapsz az AI-asszisztenshez és minden funkcióhoz — bankkártya nem szükséges, nincs kötelezettség.",
    },
    note: "Az AI-asszisztens és minden AI-generálás a csomagod része.",
    freeFeatures: {
      title: "Mit kapsz a csomagodban?",
      items: [
        "Időpontfoglalás és naptárkezelés",
        "Értékesítések és fizetések kezelése",
        "Ügyfélnyilvántartás",
        "Rendszer alapfunkciók használata",
        "Statisztikák és riportok megtekintése",
      ],
    },
    howItWorks: {
      title: "Hogyan indulsz?",
      steps: [
        {
          icon: "gift",
          title: "3 napos ingyenes próba",
          description: "Regisztrálj és próbáld ki teljes hozzáféréssel — bankkártya nem szükséges, nincs kötelezettség.",
        },
        {
          icon: "cart",
          title: "Előfizetés a próba után",
          description: "Ha tetszik, válassz Növekedés vagy Prémium csomagot. Bármikor lemondható, nincs hosszú távú elköteleződés.",
        },
        {
          icon: "clock",
          title: "AI a csomagod részeként",
          description: "Nincs külön AI-díj, nincs kreditszámlálás — az AI-asszisztens és az AI-generálás a csomagod része.",
        },
      ],
      packagesIntro: "",
      popularBadge: "Legnépszerűbb",
      creditsLabel: "",
      vatLabel: "+ ÁFA",
      oneTimeNote: "",
      packages: [],
    },
    buyModal: {
      title: "Csomagválasztás",
      subtitle: "Válaszd ki a hozzád illő csomagot.",
      oneTimeBadge: "3 napos ingyenes próba · Bankkártya nem szükséges",
      whatFitsTitle: "Mit tartalmaz?",
      selectedLabel: "Kiválasztva",
      cancel: "Mégse",
      buyCta: "Kiválasztom",
      successToast: "Sikeres előfizetés (mock)",
    },
  },
  painPoints: {
    title: "Ismerősek ezek a problémák?",
    subtitle: "Nem vagy egyedül. A legtöbb szolgáltató ugyanezekkel küzd.",
    dividerMessage: "Itt a megoldás ✨",
    points: [
      {
        title: "Amatőr megjelenés, bár profi vagy",
        description: "Tudod, hogy jó vagy a szakmádban, de a weboldalad és online jelenléted nem ezt mutatja.",
      },
      {
        title: "Bonyolult időpontfoglaló, amit senki nem használ",
        description: "Olyan funkciókkal van tele, amikre nincs szükséged, az ügyfeleid meg nem értik, hogyan foglaljanak vele.",
      },
      {
        title: "Nincs időd a növekedésre koncentrálni",
        description: "Adminisztráció, eszközök kezelése, manuális munka - a nap legnagyobb része nem az ügyfelekkel telik.",
      },
      {
        title: "Marketing? Majd ha lesz rá időm...",
        description: "Új ügyfeleket kellene szerezned, de nincs időd posztolni, kampányokat tervezni, tartalmakat készíteni.",
      },
    ],
  },
  impact: {
    badge: "SZÁMOKBAN",
    titleBefore: "Üres ígéretek helyett ",
    titleAccent: "valódi eredmények",
    titleAfter: ", amikről a Bespire használók mesélnek.",
    stats: [
      {
        value: "10+ óra",
        label: "Megtakarítás hetente",
        description: "Nincs többé négy különböző eszköz — egy hely, AI-val automatizálva.",
      },
      {
        value: "0 Ft",
        label: "Beállítási költség",
        description: "Nincs fejlesztő. Nincs dizájner. Az AI mindent elintéz helyetted.",
      },
      {
        value: "24 / 7",
        label: "Online foglalás",
        description: "Az ügyfelek éjjel-nappal foglalhatnak. A rendszer sosem zár be.",
      },
      {
        value: "5×",
        label: "Bevételi forrás",
        description: "Szolgáltatások, bérletek, kurzusok, \u00a0workshopok — egy platformon.",
      },
      {
        value: "10 perc",
        label: "Alatt használható üzleti eszközök",
        description: "Saját weboldal, marketing terv, foglalási naptár, árajánlat, heti riport — az AI elkészíti a kezedbe.",
      },
      {
        value: "80%",
        label: "Kevesebb admin",
        description: "Emlékeztetők, fizetések, ügyfélkartonok — a gép intézi.",
      },
    ],
  },
  workflowSpine: {
    badge: "HOGYAN MŰKÖDIK",
    title: "Alapok → Terv → Teendő → Automatizmus → Riport",
    subtitle: "A Bespire nem külön eszközök gyűjteménye. Egy munkafolyamat, ami a te vállalkozásod logikáját követi.",
    steps: [
      { title: "Alapok", description: "Arculat, personák, üzleti terv, versenytársak — egy élő dokumentumtár." },
      { title: "Terv", description: "44 tervezői workflow 5 témában: szerzés, megtartás, kapacitás, kínálat, csapat." },
      { title: "Teendő", description: "A feladatok fele nálad, fele az AI-nál. Piszkozat, jóváhagyás, futás-előzmény." },
      { title: "Automatizmus", description: "Win-back, bérlet-lejárat, no-show, vélemény-kérés — magától fut tovább." },
      { title: "Riport", description: "Heti-havi teljesítmény, AI-kommentár, következő lépés — nem csak számok." },
    ],
  },
  proactiveTriggers: {
    badge: "PROAKTÍV AI",
    title: "Amit az asszisztens magától észrevesz",
    subtitle: "Nem várja, hogy megkérdezd. A valós adatok alapján szól előbb, mint hogy probléma lenne.",
    items: [
      { trigger: "14 üres slot a héten", suggestion: "Kapacitásterv készítése", outcome: "Visszahívó kampány a lemorzsolódott ügyfeleknek — 30-40% visszatérési arány." },
      { trigger: "90 napja inaktív ügyfél", suggestion: "Win-back kampány", outcome: "Személyre szabott ajánlat a korábbi kedvenc szolgáltatásra — újra foglalnak." },
      { trigger: "Lejáró bérlet 7 napon belül", suggestion: "Megújító üzenet", outcome: "Automatikus megújítási link — kevesebb kieső bevétel." },
      { trigger: "No-show után 2 órával", suggestion: "Újrafoglalás ajánlása", outcome: "Udvarias emlékeztető + következő szabad időpont — slot újratöltés." },
    ],
  },
  taskBoard: {
    badge: "KÖZÖS MUNKATÁRS",
    title: "Te és az AI ugyanazon a teendőlistán",
    subtitle: "Nem külön chatbot. A Bespire felosztja közöttetek a napi feladatokat, és csak jóváhagyásra vár.",
    meColumnTitle: "Nálam",
    aiColumnTitle: "AI-nál",
    aiBadge: "Dolgozik",
    meTasks: [
      { title: "Délelőtti csúcsidő árazásának felülvizsgálata", note: "AI készített javaslatot — döntés rád vár" },
      { title: "Új csoportos óra időpontjának megerősítése", note: "3 jelentkező van, szükség van a véglegesítésre" },
    ],
    aiTasks: [
      { title: "Kovács Anna visszahívó üzenete", note: "3 hete nem foglalt", status: "Jóváhagyásra vár · WhatsApp" },
      { title: "Heti Instagram-posztok piszkozata", note: "Csoportos órára és nyitvatartásra", status: "Ütemezve · ma 18:00" },
      { title: "Lemorzsolódott 12 ügyfél kampánya", note: "90 napja inaktívak", status: "Fut · első visszajelzések érkeznek" },
    ],
    footer: "Az AI nem dönt a pénzedről és az ügyfeleidről magától. Piszkozatot készít, te jóváhagyod, ő lefuttatja.",
  },
  monthlyReport: {
    badge: "HÓNAP VÉGI RIPORT",
    title: "Ezt látod hónap végén — számok és javaslatok",
    subtitle: "Nem statikus tábla. A Bespire összefoglalja, mi történt, és megmondja, mi a következő lépés.",
    period: "Június 2026",
    periodNote: "Automatikusan generált havi zárás",
    aiGeneratedLabel: "AI generálta",
    kpis: [
      { label: "Havi bevétel", value: "1 847 000 Ft", delta: "+12% az előző hónaphoz", positive: true },
      { label: "Kihasználtság", value: "78%", delta: "+6% javulás", positive: true },
      { label: "Új ügyfél", value: "18", delta: "+5 a múlt hónaphoz", positive: true },
      { label: "Elszunnyadt", value: "23", delta: "figyelj rá", positive: false },
    ],
    insightTitle: "Fő javaslat a jövő hónapra",
    insight: "A szerda délelőtti órák kihasználtsága 2 hónapja csökken. Javaslat: 10%-os kedvezményes reggeli csomag, célzott WhatsApp kampány 45 inaktív ügyfélnek.",
  },
  channels: {
    title: "Nem kell belépned, hogy dolgozzon",
    subtitle: "Az asszisztens ott szól, ahol amúgy is vagy. A mérés és a hirdetés is ugyaninnen megy.",
    items: [
      { name: "WhatsApp", description: "Teendők, jóváhagyások, emlékeztetők — közvetlenül a telefonodon." },
      { name: "Google", description: "Mérési adatok, keresőoptimalizálási javaslatok és teljesítmény-követés." },
      { name: "Meta Ads", description: "Hirdetési kampányok, posztok és közönség-elemzés egy helyről." },
      { name: "Böngésző", description: "A teljes Bespire felület bármilyen eszközön, letöltés nélkül." },
    ],
    footer: "Nincs külön app, nincs új bejelentkezés. A Bespire a meglévő csatornáidon keresztül dolgozik veled.",
  },
  solutions: {
    title: "Egy AI asszisztens, ami tényleg mindenhez ért",
    subtitle: "Nem csak weboldalt épít vagy foglalást kezel. Napi szinten dolgozik veled — a márkádtól az adminig.",
    solutionLabel: "Terület",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaCapabilities: "Nézd meg az összes képességet →",
    items: [
      {
        id: "solution-brand",
        icon: "Palette",
        title: "Márka és stratégia",
        description: "Végigvisz az arculatod és üzleti terved teljes újragondolásán, ha kell, majd folyamatosan finomhangolja — nem csak egyszer, hanem folyamatosan.",
        features: [
          "Arculat és brand kulcsüzenetek újragondolása",
          "Personák és pozicionálás finomítása",
          "Üzleti és marketing terv készítése",
          "Új versenytárs-elemzés bármikor",
        ],
        chat: {
          title: "Márka asszisztens",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 🎨 Nézzük át a márkádat. Mi az, amiben szeretnél tisztább képet?" },
            { role: "user" as const, content: "Nem érzem, hogy jó személynek szólok. Segíts újragondolni a personákat." },
            { role: "assistant" as const, content: "Rendben. A jelenlegi ügyfél-adataid és foglalásaid alapján ezt látom:", list: [
              "👤 Fő persona: 30–45 év, dolgozó szülők, hétvégi időpont",
              "👤 Rejtett szegmens: 25–35 sportolók, esti időpont",
              "👤 Kihagyott: 50+ regeneráció-fókuszú",
            ] },
            { role: "user" as const, content: "A 25–35 sportolókra fókuszáljunk. Csinálsz róluk egy rövid brief-et?" },
            { role: "assistant" as const, content: "Kész. Új üzenet, új színek, új landing szekció — mindent összeraktam, jóváhagyás után élesítem. 🚀" },
          ],
        },
      },
      {
        id: "solution-web",
        icon: "Globe",
        title: "Weboldal, tartalom, SEO",
        description: "Nem csak felépíti a weboldalad — utána is folyamatosan tölti tartalommal, optimalizálja és fordítja új nyelvekre.",
        features: [
          "Új blogposztok, kulcsszavakkal",
          "SEO elemzés és javaslatok",
          "Weboldal fordítása új nyelvre",
          "Új képek és médiatár generálása",
        ],
        chat: {
          title: "Weboldal & tartalom",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 🌐 Miben segítsek a weboldaladdal ma?" },
            { role: "user" as const, content: "Kellene egy blogposzt a téli regenerációról, és angolul is jelenjen meg." },
            { role: "assistant" as const, content: "Rendben. Két verziót készítettem:", list: [
              "✍️ Magyar poszt: 'Téli regeneráció — 5 tipp, amit ma elkezdhetsz'",
              "🌍 Angol fordítás: 'Winter recovery — 5 tips to start today'",
              "🔍 SEO: 3 kulcsszóra optimalizálva",
            ] },
            { role: "user" as const, content: "Szuper. A meta leírást is megírod és élesíted?" },
            { role: "assistant" as const, content: "Kész. Publikáltam, sitemap frissítve, Google-nek beküldve. 📈" },
          ],
        },
      },
      {
        id: "solution-products",
        icon: "Package",
        title: "Foglalás és naptár",
        description: "Online foglalás, csoportos órák, emlékeztetők, no-show követés — a naptárad magától megy.",
        features: [
          "Online foglalás 0–24 órában",
          "Csoportos és 1:1 időpontok",
          "Automatikus emlékeztetők és naptár-szinkron",
          "No-show követés, várólista, újrahívás",
        ],
        chat: {
          title: "Termékek & foglalás",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 📦 Új szolgáltatást vagy csomagot állítunk be?" },
            { role: "user" as const, content: "Egy '10 alkalmas' bérletet szeretnék, kedvezménnyel." },
            { role: "assistant" as const, content: "Kész. Így néz ki:", list: [
              "🎫 10 alkalmas bérlet — 55.000 Ft (15% kedvezmény)",
              "⏱️ Érvényesség: 3 hónap",
              "📅 Foglalás közvetlenül a bérlet terhére",
            ] },
            { role: "user" as const, content: "Tegyél mellé egy indító kombót új ügyfeleknek." },
            { role: "assistant" as const, content: "Létrehoztam a 'Start' csomagot: 3 alkalom + konzultáció. Weboldalon már látszik. ✅" },
          ],
        },
      },
      {
        id: "solution-marketing",
        icon: "Megaphone",
        title: "Marketing és social",
        description: "Kampányok, posztok, hirdetések — nem sablonokból, hanem a saját ügyfeleid, szolgáltatásaid és foglalásaid alapján.",
        features: [
          "Instagram/Facebook posztok automatikusan",
          "Hirdetés-szövegek és képek generálása",
          "Email kampányok visszahívóknak",
          "Kampányterv egész hónapra",
        ],
        chat: {
          title: "Marketing asszisztens",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 📣 Hogy áll a hónap? Nézzük az új csoportos órát?" },
            { role: "user" as const, content: "Igen, és kell hozzá 3 poszt meg egy hirdetés." },
            { role: "assistant" as const, content: "Kész, íme a terv:", list: [
              "📸 3 Instagram poszt — hétfő, szerda, péntek",
              "🎯 Facebook hirdetés — 25–40 év, Budapest",
              "✉️ Email a régi vendégeidnek első-alkalom kedvezménnyel",
            ] },
            { role: "user" as const, content: "Indítsd élesben, napi 3.000 Ft hirdetési kerettel." },
            { role: "assistant" as const, content: "Élesítve. Naponta jelentek a teljesítményről és javaslok finomításokat. 📊" },
          ],
        },
      },
      {
        id: "solution-finance",
        icon: "Wallet",
        title: "Admin és pénzügy",
        description: "Számlázás, emlékeztetők, riportok — az adminisztráció leveszi a válladról a papírmunkát, hogy a szakmádra tudj koncentrálni.",
        features: [
          "Automatikus számlázás foglalások után",
          "Fizetési emlékeztetők késedelemnél",
          "Havi és negyedéves riportok",
          "AI kommentár a bevétel-alakulásról",
        ],
        chat: {
          title: "Admin asszisztens",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 💼 Kész a heti riport, megnézed?" },
            { role: "user" as const, content: "Mutasd a lényeget." },
            { role: "assistant" as const, content: "Röviden:", list: [
              "💰 Bevétel: 412.000 Ft (+8% előző héthez)",
              "📅 Foglalások: 47 (2 lemondás)",
              "⚠️ 3 kimenő számla lejárt — küldjek emlékeztetőt?",
            ] },
            { role: "user" as const, content: "Igen, küldd, és készíts havi kimutatást a könyvelőmnek." },
            { role: "assistant" as const, content: "Emlékeztetők kimentek, havi PDF a könyvelőnek email-ben. ✅" },
          ],
        },
      },
      {
        id: "solution-customers",
        icon: "Users",
        title: "Ügyfélkapcsolat",
        description: "Visszahívás, follow-up, értékelések kezelése — hogy az ügyfeleid ne felejtsenek el, és jobb kritikákat kapj.",
        features: [
          "Régi ügyfelek visszahívó kampányai",
          "Follow-up üzenet foglalás után",
          "Értékelés-kérés és válasz-javaslat",
          "Ügyfél-születésnapok, hűségprogramok",
        ],
        chat: {
          title: "Ügyfél asszisztens",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Szia! 👥 12 ügyfeled 3 hónapja nem foglalt. Küldjek visszahívó ajánlatot?" },
            { role: "user" as const, content: "Igen, de személyre szabva, ne legyen sablon." },
            { role: "assistant" as const, content: "Rendben. Így néz ki a stratégia:", list: [
              "✉️ Személyre szóló email a korábbi kedvenc szolgáltatással",
              "🎁 Egyedi kedvezmény (10%) — csak nekik, 7 napig",
              "📱 SMS emlékeztető 3 nap múlva",
            ] },
            { role: "user" as const, content: "Mehet. A kapott új értékeléseket is nézd át és válaszolj." },
            { role: "assistant" as const, content: "Kampány élesítve. 4 új értékelésre válasz-vázlatot készítettem, jóváhagyásra várnak. ⭐" },
          ],
        },
      },
      {
        id: "solution-daily",
        icon: "Bot",
        title: "Folyamatos AI asszisztens",
        description: "Nem egy sablonos chatbot — minden reggel felkészít a napodra, kezeli a teendőidet, proaktívan szól, és hetente-havonta üzleti riportot ad javaslatokkal.",
        features: [
          "Napi reggeli brief: foglalások, bevétel, prioritások",
          "Teendők és emlékeztetők automatikus kezelése",
          "Proaktív javaslatok: kit hívj vissza, mit posztolj ma",
          "Heti és havi üzleti riport, konkrét javaslatokkal",
        ],
        chat: {
          title: "Napi asszisztens",
          online: "Online",
          messages: [
            { role: "assistant" as const, content: "Jó reggelt! ☀️ Íme a mai briefed:", list: [
              "📅 5 foglalás (2 új ügyfél, 3 törzs)",
              "💰 Várható bevétel: 68.500 Ft",
              "⚠️ 10:30-as slot üres — visszahívó javaslat készen",
            ] },
            { role: "user" as const, content: "Mit javasolsz a mai prioritásra?" },
            { role: "assistant" as const, content: "3 dolog:", list: [
              "1. Kovács Anna 3 hete nem foglalt — küldjek üzenetet?",
              "2. A csoportos óra még nincs Instára posztolva",
              "3. 2 számla lejárt — emlékeztető mehet",
            ] },
            { role: "user" as const, content: "Mind a hármat csináld." },
            { role: "assistant" as const, content: "Kész. Este 18:00-kor összefoglalom a napot és megnézzük együtt a heti riportot. 📊" },
          ],
        },
      },
    ],
    mockupLabels: {
      website: {
        nav1: "Főoldal",
        nav2: "Szolgáltatások",
        nav3: "Árak",
        nav4: "Kapcsolat",
        heroTitle: "Alakítsd át az életed",
        heroDesc: "Személyre szabott edzéstervek és csoportos órák professzionális edző segítségével",
        heroBadge: "#1 Személyi Edző Budapesten",
        heroCta1: "Foglalj időpontot",
        heroCta2: "Tudj meg többet",
        heroVideo: "Nézd meg a videót",
        trainerPhoto: "Profi fotó",
        stat1: "Elégedett ügyfél",
        stat2: "Értékelés",
        stat3: "Év tapasztalat",
        servicesTitle: "Szolgáltatások",
        seeAll: "Összes",
        service1: "Személyi edzés",
        service2: "Csoportos órák",
        service3: "Táplálkozás",
        from: "tól",
        bookNow: "Foglalás",
        reviewerName: "Kovács Anna",
        reviewText: "Fantasztikus eredményeket értem el! A személyi edzések teljesen megváltoztatták az életem.",
        building: "AI építi az oldalad...",
      },
      booking: {
        title: "Foglalási naptár",
        month: "Március 2026",
        search: "Keresés...",
        statBooked: "Foglalás",
        statToday: "Mai",
        statRevenue: "Bevétel",
        todayLabel: "Mai időpontok",
        addNew: "Új foglalás",
        appt1: "Személyi edzés",
        appt2: "Csoportos HIIT",
        appt3: "Táplálkozási konzultáció",
        person: "fő",
        confirmed: "Megerősítve",
        reminder: "Emlékeztető elküldve",
        pending: "Függőben",
        paid: "Fizetve",
        location: "Stúdió",
        hybrid: "Hibrid",
      },
      marketing: {
        title: "Marketing Dashboard",
        period: "Elmúlt 30 nap",
        stat1: "Email küldve",
        stat2: "Megnyitás",
        stat3: "Kattintás",
        stat4: "Új ügyfél",
        chartLabel: "Heti konverziók",
        chartLegend1: "Konverzió",
        chartLegend2: "Látogató",
        vsLastWeek: "vs előző hét",
        totalConversions: "Összesen: 420 konverzió",
        campaignsLabel: "Aktív kampányok",
        viewAll: "Összes",
        campaign1: "Új HIIT óra - Instagram",
        campaign1Status: "AI generálta • Ütemezve 18:00",
        campaign2: "Havi hírlevél",
        campaign2Status: "Kiküldve • 856 címzett",
        campaign3: "Visszahívó automatizmus",
        campaign3Status: "12 ügyfél érintett • Fut",
        scheduled: "Ütemezve",
        sent: "Elküldve",
        opened: "megnyitotta",
        active: "Aktív",
      },
    },
  },
  useCases: {
    title: "Kinek való a Bespire?",
    subtitle: "Szolgáltatók széles körének segítünk a mindennapi munkában és növekedésben",
    ctaBox: {
      title: "Nem találod a szakmád?",
      description: "A Bespire bármilyen szolgáltató vállalkozásnak tökéletes megoldás. Próbáld ki ingyen!",
      button: "Indítsd el most – ingyen",
    },
    moreFeatures: "+ több",
    learnMore: "Tudj meg többet",
    cases: [
      {
        title: "Személyi edzők & Fitness termek",
        slug: "fitness-personal-trainers",
        description: "Edzéstervek online értékesítése, csoport órák szervezése, tagságok és bérletek kezelése, étrenddel kapcsolatos tanácsadás dokumentálása. Építs közösséget és növeld az ügyfélszámodat hatékonyan.",
        icon: "dumbbell",
        features: ["Edzéstervek", "Csoportos órák", "Bérletek", "Online konzultáció"],
      },
      {
        title: "Jóga & Pilates Oktatók és studiók",
        slug: "yoga-pilates-instructors",
        description: "Órarend automatikus kezelése, létszámkorlátozás beállítása, online kurzusok indítása, közösségi tér kialakítása a résztvevőknek. Kezeld könnyedén az összes órát és résztvevőt.",
        icon: "heart",
        features: ["Órarend kezelés", "Létszámkorlát", "Online kurzusok", "Közösségi tér"],
      },
      {
        title: "Gyógytornászok & Fizioterapeuták",
        slug: "physiotherapists",
        description: "Kezelési tervek dokumentálása és követése, gyakorlatok videókban bemutatása, otthoni feladatok kiadása, rehabilitációs haladás mérése. Támogasd pácienseidet a gyógyulásban.",
        icon: "activity",
        features: ["Kezelési tervek", "Gyakorlat videók", "Otthoni feladatok", "Haladás mérés"],
      },
      {
        title: "Sport Klubbok",
        slug: "sport-clubs",
        description: "Tagság és bérletkezelés automatizálva, órák és tréningek ütemezése, személyes edzők menedzselése, csoportos foglalkozások szervezése. Növeld a taglétszámot és javítsd az ügyfélélményt modern eszközökkel.",
        icon: "trophy",
        features: ["Tagság kezelés", "Órák ütemezése", "Személyi edzők", "Csoportos foglalkozások"],
      },
      {
        title: "Tanácsadók & Business Coachok",
        slug: "consultants-business-coaches",
        description: "Online konzultációs időpontok foglalása, stratégiai session-ök szervezése, dokumentumok és anyagok megosztása ügyfelekkel, automatikus follow-up rendszer. Professzionális megjelenés és hatékony munkavégzés.",
        icon: "briefcase",
        features: ["Konzultációk", "Dokumentum megosztás", "Follow-up", "Fizetési tervek"],
      },
      {
        title: "Terapeuták & Coachok",
        slug: "therapists-coaches",
        description: "Ülések és konzultációk kezelése, ügyfélkövetés és dokumentáció, online programok indítása, haladás követése. Vidd online a praxisodat és érj el több ügyfelet.",
        icon: "graduationCap",
        features: ["Kurzusok", "Tananyagok", "Vizsgák", "Haladás követés"],
      },
      {
        title: "Táplálkozási Tanácsadók",
        slug: "nutritionists",
        description: "Személyre szabott étrendek kezelése, haladás követése és elemzése, receptek megosztása, élelmiszerlista készítés. Segíts ügyféleidnek elérni céljaikat hatékony eszközökkel.",
        icon: "apple",
        features: ["Étrendek", "Haladás követés", "Receptek", "Élelmiszerlista"],
      },
      {
        title: "Pszichológusok & Mentorok",
        slug: "psychologists-mentors",
        description: "Biztonságos online térben történő találkozók szervezése, bizalmas jegyzetek kezelése titkosítva, session-ök nyomon követése, hosszú távú ügyfélkapcsolatok kezelése. Megfelelő biztonság és diszkréció.",
        icon: "brain",
        features: ["Biztonságos rendszer", "Titkosított jegyzetek", "Session tracking", "Hosszú távú nyomon követés"],
      },
      {
        title: "Fodrászok & Borbélyok",
        slug: "hairdressers-barbers",
        description: "Professzionális online időpontfoglaló, automatikus emlékeztetők, ügyfélkártya rendszer, előtte-utána galéria kezelés. Ügyfeleid 0-24 órában foglalhatnak időpontot, te pedig látod az egész napi beosztásodat egy helyen.",
        icon: "scissors",
        features: ["Online időpontfoglaló", "Automatikus emlékeztetők", "Galéria kezelés", "Ügyfélkártyák"],
      },
      {
        title: "Fotósok & Videósok",
        slug: "photographers-videographers",
        description: "Portfolió megjelenítés professzionális galériával, projektek és csomagok kezelése, időpont egyeztetés helyszínekre, anyagok megosztása és leadás ügyfeleknek. Mutasd meg munkáid és egyszerűsítsd a folyamatokat.",
        icon: "camera",
        features: ["Portfolió galéria", "Projektek", "Időpont egyeztetés", "Anyag megosztás"],
      },
      {
        title: "Kozmetikusok & Szépségszalonok",
        slug: "beauticians-beauty-salons",
        description: "Kezelési csomagok értékesítése, több munkatárs kezelése párhuzamosan, hűségprogram automatikus nyilvántartása, kezelési előzmények és jegyzetek tárolása. Emeld új szintre a szalonod működését.",
        icon: "sparkles",
        features: ["Kezelési csomagok", "Több munkatárs", "Hűségprogram", "Kezelési jegyzőkönyv"],
      },
      {
        title: "Masszőrök & Terapeuták",
        slug: "massage-therapists",
        description: "Diszkrét ügyféladatok kezelése, kezelési előzmények nyilvántartása, kezelési csomagok és bérletek értékesítése, visszatérő időpontok automatikus kezelése. Professzionális és biztonságos rendszer.",
        icon: "handHeart",
        features: ["GDPR biztonság", "Kezelési előzmények", "Csomagok", "Visszatérő foglalások"],
      },
      {
        title: "Körmös & Műkörömépítők",
        slug: "nail-technicians",
        description: "Inspirációs galéria a mintákból, színek és stílusok bemutatása, speciális kezelések kezelése, törzsvendég jutalmak automatikus nyilvántartása. Vonzz több ügyfelet gyönyörű bemutatkozással.",
        icon: "paintbrush",
        features: ["Minta galéria", "Speciális kezelések", "Törzsvendég jutalmak", "Előjegyzés"],
      },
    ],
  },
  features: {
    title: "Mire használhatod a Bespire AI asszisztenst?",
    subtitle: "Nem csak értékesítés — a vállalkozásod teljes digitális működését támogatja egy platformon.",
    groups: [
      {
        label: "Amit eladhatsz",
        title: "Bevételi források",
        subtitle: "Napi bevételtől a passzív jövedelemig — egy platformon.",
        list: [
          {
            title: "Szolgáltatások & Időpontok",
            description: "Ügyfeleid online foglalhatnak, te pedig fogadod az ügyfeleket.",
            items: [
              "Hajvágás, festés, kezelések",
              "Edzések és jóga órák",
              "Kozmetikai kezelések",
              "Masszázs és terápia",
            ],
          },
          {
            title: "Bérletek & Tagságok",
            description: "Biztosítsd magadnak az előre látható, stabil havi bevételt.",
            items: [
              "10 alkalmas edzés bérlet",
              "5 alkalmas masszázs bérlet",
              "Havi kozmetikai csomag",
              "Konzultációs csomag (3 alkalom)",
            ],
          },
          {
            title: "Csoportos Workshopok",
            description: "Szervezz eseményeket, ahol egyszerre több ügyfelet szolgálhatsz ki.",
            items: [
              "Főzőkurzus 8-10 fővel",
              "Csoportos fitness órák",
              "Sminkes workshop hétvégén",
              "Wellness retreat napok",
            ],
          },
          {
            title: "Konzultációk & Tanácsadás",
            description: "Online vagy személyes találkozók ügyfelekkel.",
            items: [
              "Táplálkozási tanácsadás online",
              "Személyes styling konzultáció",
              "Üzleti coaching sessionök",
              "Életmód tanácsadás",
            ],
          },
          {
            title: "Online Kurzusok",
            description: "Add át tudásod videókurzusokban - egyszer készíted, folyamatosan értékesíted.",
            items: [
              "Profi főzési technikák kurzus",
              "Otthoni edzésprogram csomag",
              "Smink tanfolyam kezdőknek",
              "Jóga otthoni kurzus",
            ],
          },
          {
            title: "Digitális Termékek",
            description: "Készíts útmutatókat, recepteket, sablonokat - passzív bevétel forrás.",
            items: [
              "Étrendek és edzéstervek PDF-ben",
              "Hair care útmutató e-book",
              "Business sablonok csomagja",
              "Receptkönyv letöltéssel",
            ],
          },
          {
            title: "Személyes Üzenetek",
            description: "Ügyfeleid és rajongóid személyre szabott videó- vagy chat-üzenetet kérhetnek tőled — egyedi élmény, extra bevétel.",
            items: [
              "Videós motivációs üzenet edzőtől",
              "Személyes köszöntő coach-tól",
              "Hajápolási tipp videó fodrásztól",
              "Privát chat-konzultáció kozmetikustól",
            ],
          },
        ],
      },
      {
        label: "Marketing & márka",
        title: "Így jönnek az új ügyfelek",
        subtitle: "Az AI viszi a márkádat, a marketinget és a tartalmat — te csak jóváhagyod.",
        list: [
          {
            title: "Márka és stratégia",
            description: "Az AI végigvisz az arculatod, personák és üzleti terved finomításán — és folyamatosan újragondolja, ha változik a piac.",
            items: [
              "Arculat és brand hangolása",
              "Personák és célcsoport finomítása",
              "Üzleti terv és marketing terv",
              "Versenytárs-elemzés folyamatosan",
            ],
          },
          {
            title: "Marketing és értékesítés",
            description: "Napi social posztok, hirdetési kampányok és email marketing — az AI hozza az új ügyfeleket, te csak jóváhagyod.",
            items: [
              "Social poszt és postterv (FB, IG, TikTok)",
              "Hirdetési kampányok és tervek",
              "Email kampányok, hírlevelek",
              "Régi ügyfelek aktivizálása",
              "Helyi partnerségek keresése",
            ],
          },
          {
            title: "Blog, SEO és tartalom",
            description: "Az AI folyamatosan tölti tartalommal az oldalad, optimalizálja Google-re és fordítja új nyelvekre.",
            items: [
              "Blogposztok kulcsszavakra",
              "SEO elemzés és javaslatok",
              "Új nyelvre fordítás",
              "Új képek és média generálása",
            ],
          },
          {
            title: "Eltünő ügyfelek reaktiválása",
            description: "AI által javasolt visszahívási és email sorozat azoknak, akik régen jártak nálunk — automatikus kampány, személyre szabott szövegekkel.",
            items: [
              "Régi ügyfelek listázása",
              "Személyre szabott visszahívó szövegek",
              "Automatikus reaktiváló kampány indítása",
              "Visszatérési ajánlatok generálása",
            ],
          },
          {
            title: "Hűségprogramok fejlesztése és implementálása",
            description: "Pontgyűjtő, bérlet-központú vagy kedvezményes visszatérő program kidolgozása és bevezetése az AI segítségével.",
            items: [
              "Törzsvendég pontrendszer",
              "Visszatérő foglalások ösztönzése",
              "Ajánlási program",
              "Hűségkampányok ütemezése",
            ],
          },
        ],
      },
      {
        label: "Növekedés",
        title: "Működés és növekedés",
        subtitle: "Az ügyféladatoktól a csapatbővítésig — az AI végigvezet.",
        list: [
          {
            title: "Ügyfelek és riportok",
            description: "Egy helyen minden ügyféladat és teljesítmény-számok — mély elemzéssel és konkrét AI javaslatokkal.",
            items: [
              "CRM: ügyfélprofilok, jegyzetek",
              "Vásárlói elemzések",
              "Mély teljesítmény-riport AI kommentárral",
              "Meetingre felkészülés egy kattintással",
            ],
          },
          {
            title: "Csapat és növekedés",
            description: "Amikor eljön az idő bővíteni, az AI végigvisz — a hirdetéstől az interjú-kérdésekig.",
            items: [
              "Álláshirdetés megírása",
              "Interjú-kérdéssor jelöltre szabva",
              "HR marketing kampány",
            ],
          },
          {
            title: "Napi to-do automatikus vezetése",
            description: "Az AI minden reggel összerendezi a teendőidet a foglalások, kampányok és határidők alapján — prioritásokkal és emlékeztetőkkel.",
            items: [
              "Automatikus prioritási sorrend",
              "Emlékeztetők és határidők kezelése",
              "Meetingre felkészülés",
              "Napi fókuszlista generálása",
            ],
          },
          {
            title: "Hosszú távú stratégia kialakítása és utókövetése",
            description: "Havi és negyedéves célok, üzleti terv-frissítések és KPI követés AI támogatással — folyamatos utókövetéssel.",
            items: [
              "Célkitűzések és akciótervek",
              "Negyedéves stratégiai visszatekintés",
              "KPI követés és előrejelzések",
              "Üzleti terv folyamatos frissítése",
            ],
          },
          {
            title: "Egy valódi kolléga, aki ismer téged, az üzleted és a piacod",
            description: "A Bespire tanul a vállalkozásodról, így a javaslatai egyre pontosabbak és személyre szabottabbak — olyan, mintha egy tapasztalt kollega dolgozna veled.",
            items: [
              "Vállalkozás-specifikus tudás",
              "Piaci trendek figyelése",
              "Folyamatos finomhangolás",
              "Személyre szabott javaslatok",
            ],
          },
        ],
      },
    ],
  },
  howItWorks: {
    title: "Hogyan működik?",
    subtitle: "Válaszd ki, melyik út áll hozzád közelebb",
    timeIndicator: "Indítsd el most – ingyen",
    pathA: {
      label: "Csináld magad, AI segítséggel",
      badge: "Önállóan",
      steps: [
        {
          number: "01",
          title: "Mondd el, mit csinálsz",
          description: "Pár kattintással ingyenes fiók. Az AI megismeri a vállalkozásod, céljaid és ügyfeleid — 3 napig kötelezettség nélkül próbálod.",
        },
        {
          number: "02",
          title: "Az AI felépíti a működésed",
          description: "Arculat, katalógus, marketing terv, SEO, admin folyamatok és ügyfélkommunikáció — mind egyszerre, a te adataid alapján.",
        },
        {
          number: "03",
          title: "Napi asszisztens",
          description: "Az AI javasol marketinget, kampányokat, árakat, új termékeket és visszahívandó ügyfeleket — folyamatosan optimalizál.",
        },
      ],
    },
    pathB: {
      label: "Mi megcsináljuk helyetted",
      badge: "Egyszeri 50.000 Ft + ÁFA",
      description: "Ha szeretnéd, mi vesszük le a válladról az egész beállítást és a betanítást — a teljes AI asszisztens rendszert a vállalkozásodra szabjuk, neked csak használnod kell.",
      steps: [
        {
          number: "01",
          title: "Ingyenes felmérés",
          description: "30 percben átbeszéljük a szolgáltatásaidat, ügyféltípusaidat, folyamataidat és céljaidat, hogy az AI a te vállalkozásodra legyen szabva.",
        },
        {
          number: "02",
          title: "Rád szabjuk az AI asszisztenst",
          description: "Arculat, katalógus, számlázás, marketing, kommunikáció, SEO, kampányok — a teljes napi működést felépítjük, és az AI-t a te hangodra tanítjuk.",
        },
        {
          number: "03",
          title: "Átadjuk és melletted marad",
          description: "Személyes betanítás után a Bespire minden nap dolgozik veled — mi pedig a háttérben elérhetők maradunk.",
        },
      ],
    },
  },
  testimonials: {
    title: "Amit ügyfeleink mondanak",
    items: [
      {
        name: "Nagy Éva",
        role: "Fodrász",
        location: "Budapest",
        text: "3 év után végre van egy professzionális weboldalám és nem kell egész nap a telefont nyomkodni foglalások miatt. A Bespire mindent automatizált.",
        rating: 5,
      },
      {
        name: "Kovács Márk",
        role: "Personal Trainer",
        location: "Debrecen",
        text: "Korábban 10-15 ügyfelem volt, most 40+ állandó kliensem van. Az online időpontfoglaló és a marketing AI csodát tett.",
        rating: 5,
      },
      {
        name: "Fitness Plus Stúdió",
        role: "Jóga és Pilates",
        location: "Szeged",
        text: "6 oktatóval dolgozunk és korábban káosz volt a naptár. Most minden szervezett, az ügyfelek elégedettek, mi pedig spóroljuk az időt.",
        rating: 5,
      },
    ],
  },
  cta: {
    title: "Indítsd el vállalkozásod új szinten",
    subtitle: "Csatlakozz több száz elégedett szolgáltatóhoz",
    button: "Kipróbálom ingyen",
    note: "Nincs szükség bankkártyára • 3 napos ingyenes próba • Bármikor lemondható",
  },
  faq: {
    title: "Gyakori kérdések",
    categories: [
      {
        name: "Általános",
        icon: "info",
        questions: [
          {
            q: "Hogyan tudok azonnal elindulni?",
            a: "Két út van: (1) Ingyenes regisztráció után 10 perc alatt beszélgetsz az AI-val és élesíted a saját oldalad — bankkártya nem szükséges, 3 napig ingyenes. (2) Kérsz visszahívást, és 48 órán belül felhívunk egy 30 perces beszélgetésre, ahol mi felépítjük neked a teljes rendszert (50 000 Ft + ÁFA egyszeri díj).",
          },
          {
            q: "Kell hozzá technikai tudás?",
            a: "Egyáltalán nem! Az AI asszisztens végigvezet minden lépésen, és mindent automatikusan beállít neked. Ha beszélsz az ügyfeleddel, akkor használni tudod a Bespire-t.",
          },
          {
            q: "Mennyi idő alatt indul be?",
            a: "10 perc alatt kész a weboldal és az időpontfoglaló rendszer. Azonnal kezdhetsz ügyfeleket fogadni.",
          },
          {
            q: "Kinek való a Bespire?",
            a: "Szolgáltatóknak, akár van már időpontfoglaló, online fizetési rendszer és saját weboldaluk, akár újat akarnak: fodrászok, kozmetikusok, személyi edzők, jógaoktatók, gyógytornászok, masszőrök, dietetikusok, pszichológusok és bármely más szolgáltató, aki ügyfeleket fogad.",
          },
          {
            q: "Miben más a Bespire, mint a ChatGPT, a Gemini vagy a Claude?",
            a: "A ChatGPT, a Gemini vagy a Claude kiválóak általános tartalomkészítésre, de önmagukban nem ismerik az üzletedet, nem kapcsolódnak a naptáradhoz, ügyfeleidhez, foglalásaidhoz vagy fizetéseidhez. A Bespire egy szolgáltatóknak épített AI asszisztens: a weboldalad, a foglalási rendszered, a marketinged, az adminisztrációd és a napi feladataid egy helyen, az üzleti adataiddal együttműködve segít.",
          },
          {
            q: "Kell letöltenem valamilyen alkalmazást?",
            a: "Nem, a Bespire teljesen böngészőalapú, telefonról és számítógépről egyaránt elérhető. Nincs szükség telepítésre — csak nyisd meg a böngészőt és használd.",
          },
          {
            q: "Hány ügyfelet és foglalást kezel a rendszer?",
            a: "Korlátlan ügyfelet és foglalást kezelhetsz a Standard csomagban is. A rendszer úgy lett tervezve, hogy növekedjen veled — akár napi több tucat foglalást is simán kezel.",
          },
        ],
      },
      {
        name: "Árazás és csomagok",
        icon: "creditCard",
        questions: [
          {
            q: "Mennyibe kerül a Bespire?",
            a: "A Növekedés csomag 12 900 Ft + ÁFA/hó, a Prémium 24 900 Ft + ÁFA/hó. Mindkét csomag tartalmazza az AI-asszisztenst. 3 napos ingyenes próba, bankkártya nélkül. Csak akkor fizetsz jutalékot, ha online értékesítesz rajtunk keresztül: 4% + 120 Ft tranzakciónként. Helyszíni fizetésnél nincs jutalék.",
          },
          {
            q: "Mit tartalmaz a Növekedés csomag?",
            a: "Mindent, amire szükséged van: professzionális weboldal, időpontfoglaló rendszer, bérletek és tagságok kezelése, korlátlan munkatárs hozzáadása, saját domain, automatikus marketing eszközök, részletes statisztikák — plusz AI-asszisztens és AI-generálás a napi munkádhoz.",
          },
          {
            q: "Van keret vagy limit az AI-használatnál?",
            a: "Nincs külön AI-díj. Az AI-asszisztens és az AI-generálás (szöveg, kép, weboldal) a csomagod része, a napi munkádhoz. Nincs kreditszámlálás, nincs meglepetés. Kampányidőszakban vagy extrém terhelésnél extra kapacitás igényelhető.",
          },
          {
            q: "Mit jelent a „normál üzleti használat”?",
            a: "Egy normál üzleti napi működést fedez le — a napi tartalomkészítéstől a kampányidőszakok intenzívebb generálásáig. Csak extrém, automatizált vagy nem üzleti célú terhelésnél jelzünk vissza. A valós vállalkozói használat a csomagod része — nincs külön korlát vagy díj.",
          },
          {
            q: "Van ingyenes próbaidőszak?",
            a: "Igen! 3 napig teljesen ingyen kipróbálhatod a teljes rendszert, bankkártya nem szükséges a regisztrációhoz. Ha tetszik, utána 12 900 Ft + ÁFA/hó áron folytathatod a Növekedés csomaggal.",
          },
          {
            q: "Mikor kell online fizetés kezelés díjat fizetnem?",
            a: "Helyszíni fizetés esetén nem számítunk fel online fizetés kezelés díjat - teljesen ingyenes. Online fizetéskor 4% + 120 Ft tranzakciónként.",
          },

          {
            q: "Mi az az egyszeri setup csomag?",
            a: "Az 50.000 Ft + ÁFA áras 'Teljes körű setup' csomaggal a csapatunk mindent beállít helyetted: weboldal felépítése, termékek és szolgáltatások feltöltése, foglalási rendszer konfigurálása, e-mail marketing és SEO optimalizálás, közösségi média integráció, valamint személyes platform használati oktatás. Te csak elindulsz, mi megcsináljuk a többit.",
          },
          {
            q: "Kötelező a setup csomagot megvenni?",
            a: "Nem, teljesen opcionális! Az AI asszisztens segítségével te magad is beállíthatsz mindent. A setup csomag azoknak ideális, akiknek  nincs idejük, és azonnal egy kész, működő rendszert szeretnének.",
          },
          {
            q: "Mi történik a próbaidőszak után, ha nem fizetek?",
            a: "A próbaidőszak végén fiókodat felfüggesztjük, de nem töröljük. 30 napig még bármikor visszatérhetsz és aktiválhatod az előfizetést — minden adatod megmarad.",
          },
        ],
      },
      {
        name: "Foglalási rendszer",
        icon: "calendar",
        questions: [
          {
            q: "Hogyan működik a Bespire foglalási rendszere?",
            a: "Foglalási rendszer: integrált része a weboldaladnak, nem irányít át külső felületre.",
          },
          {
            q: "Hogyan kezelhetem a naptáram chat-en keresztül?",
            a: "Írj az AI-nak természetes nyelven, pl: 'Tegyél be egy találkozót holnap 14:00-ra Nagy Évával'. Az AI megérti, végrehajtja és értesíti az érintetteket - mintha egy személyi asszisztensed lenne.",
          },
          {
            q: "Hogyan működik a bérletrendszer?",
            a: "Rugalmas bérleteket hozhatsz létre: alkalmas, időkorlátos vagy kombinált. Foglaláskor automatikusan levonódik, lejárati figyelmeztetést küldünk, látod ki hány alkalommal rendelkezik.",
          },
          {
            q: "Tudok csoportos órákat kezelni?",
            a: "Igen! Beállíthatod a maximális létszámot, megtelt óránál automatikus várólista indul. Ha valaki lemondja, az első várakozó értesítést kap.",
          },
          {
            q: "Szinkronizálható a Google Naptárral?",
            a: "Igen! Kétirányú szinkronizáció Google Naptárral: a Bespire foglalások megjelennek a Google Naptáradban, és a privát eseményeid is blokkolják az időpontokat, így nincs ütközés.",
          },
          {
            q: "Hogyan működik a várólista?",
            a: "Ha egy időpont vagy csoportos óra betelik, az érdeklődők automatikusan felkerülnek a várólistára. Lemondás esetén az első várakozó azonnal értesítést kap és lefoglalhatja a helyet.",
          },
          {
            q: "Több helyszínt vagy termet is tudok egyszerre kezelni?",
            a: "Igen! Több helyszínt, termet vagy szolgáltatási pontot is kezelhetsz egyetlen fiókból. Minden helyszínhez külön naptárat, szolgáltatáslistát és munkatársakat rendelhetsz.",
          },
        ],
      },
      {
        name: "Fizetés és számlázás",
        icon: "receipt",
        questions: [
          {
            q: "Milyen fizetési módokat támogat?",
            a: "Online bankkártyás fizetés (Visa, Mastercard), Apple Pay, Google Pay. Helyszíni fizetésnél (készpénz, terminál) nincs platform jutalék.",
          },
          {
            q: "Tudok számlát kiállítani?",
            a: "Igen! Kötheted a szalonhoz vagy munkatársanként külön számlázóhoz - tökéletes alvállalkozóknak. Magyar és nemzetközi számlázás, ÁFA kezelés támogatott.",
          },
          {
            q: "Hány munkatársat adhatok hozzá?",
            a: "Korlátlan számút - nem fizetsz többet érte! Minden munkatárs saját naptárat és jogosultságokat kap.",
          },
          {
            q: "Mikor kapom meg a pénzt az online fizetésekből?",
            a: "A kifizetéseket hetente indítjuk, és a pénz általában 2-3 munkanapon belül megérkezik a bankszámládra a kifizetéstől számítva. A kifizetéseket a platformon belül tudod nyomon követni.",
          },

          {
            q: "Milyen pénznemeket támogat a rendszer?",
            a: "Elsődlegesen forint (HUF) és euró (EUR) fizetést támogatunk.",
          },
        ],
      },
      {
        name: "Weboldal és technikai",
        icon: "globe",
        questions: [
          {
            q: "Mi van, ha már van weboldalám?",
            a: "Add meg az URL-t és az AI áthozza a képeket, leírásokat, szolgáltatásokat. Egy gyönyörű új weboldalt építünk a meglévő tartalmaidból.",
          },
          {
            q: "Használhatom a saját domain névemet?",
            a: "Igen! Csatlakoztathatod a saját domained (pl. www.szepfodraszat.hu) vagy használhatod az ingyenes Bespire aldomaint (pl. szepfodraszat.bespire.app).",
          },
          {
            q: "Biztonságos az adattárolás?",
            a: "Abszolút! EU-s szervereken, titkosítva, GDPR kompatibilis módon tároljuk az adatokat. Te döntöd el, ki férhet hozzá.",
          },
          {
            q: "Felhasználjátok az adataimat valamire?",
            a: "Nem! Az adataid kizárólag a te szolgáltatásaid működtetéséhez szükségesek. Nem adjuk el, nem osztjuk meg harmadik féllel, nem használjuk marketing célokra és nem használjuk AI modellek tanítására sem. Az adataid a tiéd — mi csak biztonságban tároljuk őket.",
          },
          {
            q: "Hol vannak az adataim tárolva?",
            a: "Minden adatot az Európai Unión belüli szervereken tárolunk, titkosított formában. A GDPR előírásait maradéktalanul betartjuk, és rendszeres biztonsági auditokat végzünk.",
          },
          {
            q: "Feltölthetek galériát vagy portfóliót?",
            a: "Igen! 20 GB adattárhelyen tölthetsz fel képeket és videókat a weboldaladra. Galériát, előtte-utána képeket, referenciamunkákat — mind megjeleníthetők az oldalon.",
          },
          {
            q: "SEO-optimalizált a weboldal?",
            a: "Igen! A Bespire-on készült weboldalak automatikusan SEO-optimalizáltak: gyors betöltés, mobilbarát megjelenés, meta címek és leírások, strukturált adatok — hogy az ügyfelek megtaláljanak a Google-ben.",
          },
          {
            q: "Tudok többnyelvű weboldalt csinálni?",
            a: "Igen! A weboldaladat több nyelven is elérhetővé teheted. Az AI segít a fordításban, de természetesen te is szerkesztheted a szövegeket minden nyelven.",
          },
          {
            q: "Mi történik az adataimmal, ha elhagyom a platformot?",
            a: "Az adataid a tiéd! Lemondás előtt exportálhatod az ügyféllistádat, foglalásaidat és számláidat. A fiókodat 30 napig megőrizzük a lemondás után, ha meggondolnád magad.",
          },
        ],
      },
      {
        name: "AI asszisztens",
        icon: "sparkles",
        questions: [
          {
            q: "Miben segít az AI a napi működésben — nem csak induláskor?",
            a: "Az onboarding után is veled marad. Chat-ben szólsz neki, és megcsinálja: új blogposzt, social kampány, hirdetési terv, email kiküldés, teljesítmény-riport, vagy akár álláshirdetés — te csak jóváhagyod.",
          },
          {
            q: "Tud social postokat és hirdetéseket generálni?",
            a: "Igen — Facebook, Instagram és TikTok postokat, teljes hirdetési kampányokat és postterveket készít. Márkádra hangolva, képekkel, hashtagekkel és időzítéssel.",
          },
          {
            q: "Készít blogposztokat és SEO tartalmakat?",
            a: "Igen. Megadod a kulcsszavakat vagy a témát, és az AI megírja a blogposztot, kioptimalizálja SEO-ra, elhelyezi az oldaladon és lefordítja új nyelvekre is.",
          },
          {
            q: "Van CRM és ügyfélelemzés?",
            a: "Igen. Minden ügyfélről egyben látod a foglalásait, kiadásait és jegyzeteit. Az AI mély teljesítmény-riportot készít saját kommentárral és javaslatokkal — mibe érdemes energiát tenned.",
          },
          {
            q: "Segít üzleti terv, personák és versenytárs-elemzés készítésében?",
            a: "Igen. Az AI folyamatosan finomítja az arculatod, personákat, üzleti és marketing tervet, és rendszeresen új versenytárs-elemzést készít neked.",
          },
          {
            q: "Segít csapatbővítésben is?",
            a: "Igen. Álláshirdetést ír, interjú-kérdéssort állít össze a pozícióra és a jelöltre szabva, és HR marketing kampányt is indít neked.",
          },
          {
            q: "Email kampányokat is tud küldeni?",
            a: "Igen — hírleveleket, email kampányokat és visszahívó üzeneteket ír és küld ki a régi ügyfeleknek. Az AI szegmentál és javasol témát is.",
          },
        ],
      },
      {
        name: "Támogatás",
        icon: "headphones",
        questions: [
          {
            q: "Milyen támogatást kapok?",
            a: "Chat-alapú ügyfélszolgálat munkanapokon, AI asszisztens 0-24, részletes tudásbázis és videós útmutatók.",
          },
          {
            q: "Mi történik, ha lemondom?",
            a: "Bármikor lemondhatod, nincsenek hosszú szerződések vagy rejtett feltételek. Adataidat 30 napig tároljuk a lemondás után.",
          },
          {
            q: "Van onboarding segítség az induláshoz?",
            a: "Igen! Az AI asszisztens lépésről lépésre végigvezet a beállításon. Emellett videós útmutatókat, tudásbázist és chat-es támogatást is kapsz.",
          },
          {
            q: "Milyen gyakran jönnek új funkciók?",
            a: "Folyamatosan fejlesztjük a platformot — általában havonta adunk ki frissítéseket. A felhasználói visszajelzések alapján priorizáljuk az új funkciókat, és minden frissítésről értesítünk.",
          },
          {
            q: "Kérhetek egyedi funkciót?",
            a: "Persze! Szívesen fogadunk javaslatokat — a legnépszerűbb kéréseket beépítjük a rendszerbe.",
          },
        ],
      },
    ],
  },
  socialProof: {
    testimonialTitle: "Így segít a Bespire Gonda Cilinek",
    testimonialSubtitle: "Valódi ügyfél, valódi tapasztalat — nézd meg, hogyan változott meg a mindennapja.",
    customersTitle: "És további több száz szolgáltató dolgozik a Bespire-rel",
    customersSubtitle: "Élő oldalak, valódi ügyfelek. Kattints és nézd meg, milyen oldalakat épít az AI.",
    videoAriaLabel: "Indítsd el az ügyfél interjú videót",
    videoBadge: "Ügyfél interjú",
    durationLabel: "10 perc",
    openLive: "Nyisd meg élőben →",
    viewSite: "Nézd meg az oldalát élőben →",
    startYourOwn: "Indítsd el a sajátodat 10 perc alatt →",
    defaultQuote: "A Bespire nem csak egy weboldal, ez a vállalkozói szabadságom kulcsa",
    professions: {
      manualTherapist: "Manuál terapeuta",
      lifestyleCoach: "Életmód coach",
      dietitian: "Dietetikus",
      therapist: "Terapeuta",
    },
  },
  callbackForm: {
    title: "Segítségre van szükséged? 48 órán belül felhívunk",
    description: "Munkanapokon. Teljesen ingyenes és kötelezettség nélküli. Nem értékesítünk telefonon — csak megnézzük, hogy a Bespire passzol-e a vállalkozásodhoz, és ha igen, megbeszéljük a következő lépést.",
    whatYouGetTitle: "Mit kapsz a hívásban",
    benefits: [
      "Konkrét javaslat a te szolgáltatásodra szabva",
      "Időkeret és árajánlat (ha kéred)",
      "Nem küldünk hírlevelet, nem hívunk újra",
    ],
    successTitle: "Köszönjük, máris regisztráltuk a kérésed.",
    successDescription: "48 órán belül felhívunk munkanapokon a megadott számon.",
    successCta: "Amíg vársz, próbáld ki az AI-t — 10 perc alatt élő oldalad lehet",
    phoneLabel: "Telefonszám",
    emailLabel: "Email",
    emailOptional: "(opcionális)",
    emailPlaceholder: "te@example.com",
    submitButton: "Hívjanak vissza",
    privacyNote: "Az adataidat bizalmasan kezeljük (GDPR). A visszahívás teljesen ingyenes és nem értékesítési hívás.",
  },
  accordion: {
    creditsDetails: "Részletek",
  },
  useCasesAria: {
    prev: "Előző",
    next: "Következő",
  },
  proAlts: {
    presentation: "Edzőterem - személyi edzők munka közben",
    collaboration: "Kozmetikus szakmai munka közben",
    discussion: "Jógaoktató csoportos órán",
    meeting: "Masszőr kezelés közben",
    brainstorm: "Fodrász munkája a szalonban",
  },
  proCta: {
    title: "Oktatóközpont vagy szakmai szervezet vagy?",
    description: "Saját marketplace, képzéskezelés, digitális tartalmak értékesítése — kulcsrakész megoldás szakmai szervezeteknek és oktatóközpontoknak.",
    button: "Érdekel",
  },
  smbPricingPage: {
    seo: {
      title: "Árazás – Bespire | Átlátható havidíj, nulla meglepetés",
      description: "Egy ár, két út: csináld magad AI-val vagy mi beüzemeljük helyetted. Egy platform minden alapfunkcióval, AI-asszisztens a csomagban, jutalékok és kifizetések egy helyen.",
    },
    hero: {
      badge: "Árazás",
      title: "Átlátható árazás. Nulla meglepetés.",
      subtitle: "Fix havidíj, minden funkcióhoz hozzáférés.\u00a0",
      trustPoints: [
        "3 napos ingyenes próba",
        "AI-asszisztens a próba alatt",
        "Nincs kártya szükség",
        "Bármikor lemondható",
      ],
    },
    plansHeading: {
      title: "Válaszd ki a hozzád illő csomagot",
      subtitle: "Mindkét csomag ugyanazokat az AI-funkciókat és alapfunkciókat tartalmazza — a különbség a napi használat intenzitásában van.",
    },
    billingToggle: {
      monthly: "Havi",
      annual: "Éves",
      saveBadge: "2 hónap ingyen",
      annualHint: "Éves előfizetéssel 2 hónapot elengedünk — a havi ár × 10 az éves díj.",
    },
    fairUseReassurance:
      "A csomagod tartalmazza az AI-asszisztens normál napi használatát. Kampányidőszakban, nagyobb terhelésnél vagy extrém automatizált használatnál extra kapacitás igényelhető.",
    quickWins: {
      title: "Mire használhatod már ma",
      items: [
        { text: "Írass meg egy Instagram posztot", eta: "~10 mp" },
        { text: "Válaszoltass egy elégedetlen vevő üzenetére", eta: "~30 mp" },
        { text: "Generáltass egy teljes weboldal-oldalt új szolgáltatáshoz", eta: "~2 perc" },
        { text: "Íratass meg egy üzleti tervet bővítéshez", eta: "~5 perc" },
      ],
      more: {
        title: "…és még sok minden más",
        description: "Hírlevelek, ajánlatok, blogposztok, képgenerálás, SEO-szövegek, ügyfélválaszok, kampányötletek — bármit, ami írható vagy generálható, ránk bízhatsz.",
      },
    },
    tsmtPartner: {
      badge: "TSMT® partner",
      title: "TSMT® terapeuta vagy?",
      description: "Hivatalos TSMT® terapeutáknak — érvényes nyilvántartási számmal — partneri kedvezményt biztosítunk a Növekedés és Prémium csomagra, havi és éves fizetésnél egyaránt.",
      year1Label: "1. év",
      year1Value: "−40%",
      year2Label: "2. év",
      year2Value: "−20%",
      examplesHeading: "Példa nettó árak",
      examples: [
        "Növekedés 12 900 Ft → 1. év: 7 740 Ft/hó · 2. év: 10 320 Ft/hó",
        "Prémium 24 900 Ft → 1. év: 14 940 Ft/hó · 2. év: 19 920 Ft/hó",
      ],
      disclaimer: "Nettó árak, + ÁFA. A kedvezményt a TSMT®-nyilvántartási szám alapján igazoljuk.",
      ctaPrimary: "Igénylés nyilvántartási számmal",
      ctaSecondary: "Mi ez?",
    },

    plans: {
      standard: {
        title: "Növekedés",
        price: "12 900 Ft",
        priceSuffix: " + ÁFA / hó",
        highlight: "Kis–közepes AI-intenzitás",
        usageBadge: "Kb. napi 5–10 AI-feladat",
        note: "3 napos ingyenes próba, teljes hozzáférés",
        rollover: "",
        annual: {
          price: "10 750 Ft",
          priceSuffix: " + ÁFA / hó",
          perYearLabel: "Éves díj: 129 000 Ft + ÁFA",
          saveLabel: "Megtakarítás: 25 800 Ft / év",
        },
        features: [
          "Teljes rendszer: weboldal, foglalás, fizetés",
          "AI a napi munkádhoz — a csomag részeként",
          "Több felhasználó és több helyszín kezelése",
          "Automatikus marketing eszközök",
          "Saját domain és magyar nyelvű ügyfélszolgálat",
        ],
        aiCapabilitiesTitle: "Amit az AI-val megcsinálhatsz",
        aiCapabilityGroups: [
          {
            title: "Social média és tartalom",
            items: [
              "Instagram és Facebook posztok szöveggel és képpel",
              "TikTok script- és videó-ötletek",
              "Story és Reels caption-ek",
              "Hashtag- és időzítés-javaslatok",
              "Heti tartalomnaptár vázlat",
            ],
          },
          {
            title: "Weboldal és SEO",
            items: [
              "Új aloldal vagy landing page szöveg",
              "Termék- és szolgáltatás-leírások",
              "Blog vázlat és bevezető",
              "Meta title és leírás",
              "GYIK bővítés és átfogalmazás",
            ],
          },
          {
            title: "Ügyfélkommunikáció",
            items: [
              "E-mail alapú ügyfélválaszok és sablonok",
              "Foglalás- és emlékeztető-sablonok",
              "Panaszkezelő válaszok",
              "Ajánlati e-mail vázlat",
              "Köszönő- és utánkövető üzenetek",
            ],
          },
          {
            title: "Marketing kampányok",
            items: [
              "Hírlevél szöveg és tárgy",
              "Szezonális kampány-ötletek",
              "Egyszerű A/B alternatívák",
              "Social hirdetés szöveg-vázlat",
            ],
          },
          {
            title: "Üzleti feladatok",
            items: [
              "Rövid üzleti terv vázlat",
              "Árazási javaslatok",
              "Versenytárs-összefoglaló",
              "Meeting-jegyzet összefoglalás",
            ],
          },
        ],
        cta: "Indítsd el ingyen",
        footnote: "Bankkártya nem szükséges · 3 napos teljes hozzáférés",
        trustNote: "Bármikor lemondhatod · Kötelezettség nélkül",
        extraTitle: "Kinek ajánljuk?",
        extraDescription: "Egyéni szolgáltatóknak és kis csapatoknak, akik szeretnék az AI-t marketingre, tartalomra és weboldalra használni.",
        extraExample: "Példa: kb. heti 3–5 poszt, alkalmi weboldal-frissítés, néhány időpont manuális kezelése.",
      },
      pro: {
        title: "Prémium",
        badge: "Legnépszerűbb",
        price: "24 900 Ft",
        priceSuffix: " + ÁFA / hó",
        highlight: "Intenzív AI-használat",
        usageBadge: "Napi 20+ AI-feladat, több felhasználó és helyszín",
        note: "3 napos ingyenes próba, teljes hozzáférés",
        rollover: "",
        annual: {
          price: "20 750 Ft",
          priceSuffix: " + ÁFA / hó",
          perYearLabel: "Éves díj: 249 000 Ft + ÁFA",
          saveLabel: "Megtakarítás: 49 800 Ft / év",
        },
        features: [
          "Minden, ami a Növekedés csomagban — intenzívebb használatra optimalizálva",
          "Prioritásos ügyfélszolgálat — gyorsabb válaszidő intenzív működéshez",
          "Nagyobb terhelhetőség kampányidőszakban — akár napi 20+ AI-feladat",
        ],
        aiCapabilitiesTitle: "Ugyanazok az AI-funkciók, intenzívebb használattal",
        aiCapabilityGroups: [
          {
            title: "Social média és tartalom",
            items: [
              "Instagram és Facebook posztok szöveggel és képpel",
              "TikTok script- és videó-ötletek",
              "Story és Reels caption-ek",
              "Hashtag- és időzítés-javaslatok",
              "Heti tartalomnaptár vázlat",
            ],
          },
          {
            title: "Weboldal és SEO",
            items: [
              "Új aloldal vagy landing page szöveg",
              "Termék- és szolgáltatás-leírások",
              "Blog vázlat és bevezető",
              "Meta title és leírás",
              "GYIK bővítés és átfogalmazás",
            ],
          },
          {
            title: "Ügyfélkommunikáció",
            items: [
              "E-mail alapú ügyfélválaszok és sablonok",
              "Foglalás- és emlékeztető-sablonok",
              "Panaszkezelő válaszok",
              "Ajánlati e-mail vázlat",
              "Köszönő- és utánkövető üzenetek",
            ],
          },
          {
            title: "Marketing kampányok",
            items: [
              "Hírlevél szöveg és tárgy",
              "Szezonális kampány-ötletek",
              "Egyszerű A/B alternatívák",
              "Social hirdetés szöveg-vázlat",
            ],
          },
          {
            title: "Üzleti feladatok",
            items: [
              "Rövid üzleti terv vázlat",
              "Árazási javaslatok",
              "Versenytárs-összefoglaló",
              "Meeting-jegyzet összefoglalás",
            ],
          },
        ],
        cta: "Indítsd el ingyen",
        footnote: "Bankkártya nem szükséges · 3 napos teljes hozzáférés",
        trustNote: "Bármikor lemondhatod · Kötelezettség nélkül",
        extraTitle: "Kinek ajánljuk?",
        extraDescription: "Vállalkozásoknak és csapatoknak, akik intenzívebben használják az AI-t — több poszt, több kampány, több helyszín, több felhasználó — és prioritásos támogatást szeretnének.",
        extraExample: "Példa: napi több poszt, rendszeres kampányok, többszöri weboldal-szerkesztés, több helyszín és munkatárs aktív kezelése.",
      },
      setup: {
        title: "Mi beüzemeljük helyetted",
        price: "50 000 Ft",
        priceSuffix: " + ÁFA egyszeri",
        note: "utána az általad választott havidíj (Növekedés vagy Prémium)",
        description: "Ha nincs időd magad beállítani a rendszert, a csapatunk feltölti a szolgáltatásaidat, beüzemeli a foglalást, a fizetést, a domainedet, és személyesen betanít.",
        cta: "Kérek visszahívást",
        footnote: "Munkanapokon 48 órán belül felhívunk · ingyenes és kötelezettség nélküli",
      },
    },
    creditsRollover: {
      title: "",
      description: "",
    },
    chatFreeExamples: [
      "Marketing ötletelés, kampányterv",
      "Szövegek csiszolása, átírása",
      "Kérdések az AI-asszisztensről, beállítási segítség",
    ],



    bothPlansInclude: {
      badge: "Mindkét csomagban",
      title: "Egy előfizetés, minden, amire szükséged van",
      subtitle: "A Növekedés és a Prémium csomag ugyanazt a rendszert és ugyanazokat az AI-funkciókat adja. A különbség a napi használat intenzitásában van.",
      system: {
        title: "Rendszer",
        items: [
          "Weboldal saját domainnel",
          "Online időpontfoglaló és e-mail emlékeztetők",
          "Bérletek, csomagok, tagdíjak",
          "Online és helyszíni fizetés",
          "Automatikus számlázás Számlázz.hu-val",
          "Ügyfélnyilvántartás",
          "Munkatársak hozzáadása",
          "Saját arculat: színek, logó",
        ],
      },
      ai: {
        title: "AI-asszisztens a napi munkádhoz",
        items: [
          "Beszélgetős AI-asszisztens magyarul",
          "Szöveg-generálás: posztok, hírlevél, termékleírás, SEO",
          "Kép-generálás a márkádhoz",
          "Weboldal- és aloldal-generálás",
          "Marketing- és kampányötletek, tartalomnaptár",
        ],
        fairUseNote: "A csomagod része, nincs külön AI-díj. Korlátlan, tisztességes használat mellett — kampányidőszakban vagy extrém terhelésnél extra kapacitás igényelhető.",
      },
      trial: {
        badge: "3 napos ingyenes próba",
        note: "Regisztráció után 3 napig teljes hozzáférést kapsz mindenhez — bankkártya nem kell.",
      },
    },

    alwaysIncluded: {
      title: "Egy platform, minden alapfunkció",
      subtitle: "A csomagod tartalmazza a teljes rendszert — a különbség a napi használat intenzitásában van.",

      categories: [
        {
          title: "Foglalás és naptár",
          items: [
            "Korlátlan időpontfoglalás",
            "Automatikus emlékeztetők (e-mail)",
            "Csoportos órák és várólista",
            "Naptár szinkronizáció",
            "Több helyszín, terem, munkatárs kezelése",
          ],
        },
        {
          title: "Fizetés és bérletek",
          items: [
            "Online fizetés (bankkártya, Apple Pay)",
            "Helyszíni fizetés rögzítése",
            "Bérletek, csomagok, tagdíjak",
            "Automatikus számlázás",
            "Heti automatikus kifizetés a bankszámládra",
          ],
        },
        {
          title: "Weboldal és márka",
          items: [
            "Professzionális weboldal (mobilbarát)",
            "Saját domain bekötése",
            "Korlátlan oldal és aloldal",
            "Keresőoptimalizált weboldal",
            "Saját arculat, színek, logó",
          ],
        },
        {
          title: "Ügyfelek és csapat",
          items: [
            "Korlátlan ügyfélnyilvántartás",
            "Korlátlan munkatárs hozzáadása",
            "Ügyféljegyzetek és előzmények",
            "Részletes statisztikák és riportok",
            "Web-alapú platform, telepítés nélkül",
          ],
        },
      ],
    },
    credits: {
      badge: "AI-asszisztens a csomagban",
      title: "AI a napi munkádhoz — a csomag részeként",
      subtitle: "Az AI-asszisztens és minden AI-generálás (szöveg, kép, weboldal) a napi munkádhoz — a csomagod részeként. Nincs külön AI-díj, nincs kreditszámlálás, nincs meglepetés.",
      whatIsTitle: "Mit jelent, hogy a csomag része?",
      whatIsDescription: "A csomagod díja tartalmazza az AI-asszisztens és az AI-generálás napi használatát a normál üzleti működéshez. Kampányidőszakban, nagyobb terhelésnél vagy extrém, automatizált használatnál extra kapacitás igényelhető.",
      examplesTitle: "Így használhatod nap mint nap",
      packagesTitle: "",
      packagesIntro: "",
      freeBadge: "3 napos ingyenes próba",
      freeNote: "Regisztráció után 3 napig teljes hozzáférést kapsz az AI-asszisztenshez és minden funkcióhoz — bankkártya nem kell.",
      monthlyIncluded: {
        title: "Mit tartalmaz mindkét csomag",
        standard: "Növekedés: AI-asszisztens a napi munkádhoz",
        pro: "Prémium: AI-asszisztens a napi munkádhoz — több felhasználó, prioritásos támogatás",
        overflow: "Nincs külön AI-díj, nincs kreditszámlálás — használd a csomagod keretei között, amikor és amire szükséged van.",
      },
      chatFree: {
        title: "AI-asszisztens és AI-generálás — a csomag részeként",
        description: "Beszélgethetsz az AI-val marketing ötletekről, szövegeket írhattok együtt, generálhatsz posztot, képet vagy weboldalt — mindezt a csomagod részeként.",
      },
    },

    payments: {
      badge: "Fizetés és díjak",
      title: "Csak az online fizetéseknél van kártyás fizetési díj",
      subtitle: "Helyszíni fizetésnél (kártya, készpénz, átutalás) semmilyen díjat nem vonunk le. Online fizetésnél a kártyás fizetési díj a szolgáltatót illeti — nem Bespire-bevétel, csak a tranzakció közös költsége.",
      cards: [
        {
          title: "Helyszíni fizetés",
          highlight: "0 Ft díj",
          description: "Készpénz, kártya vagy átutalás esetén nem vonunk le semmit. Te szeded be, te tartod meg.",
        },
        {
          title: "Kártyás fizetési díj (online)",
          highlight: "4% + 120 Ft",
          description: "Tranzakciónként, a fizetési szolgáltatónak fizetendő közös költség. Ez nem Bespire-bevétel — mi nem keresünk ezen semmit.",
        },
        {
          title: "Heti kifizetés",
          highlight: "Hetente",
          description: "Az online bevételeidet hetente automatikusan átutaljuk a bankszámládra, a tranzakciótól számított 2-3 munkanapon belül.",
        },
      ],
      invoicing: {
        badge: "Számlázz.hu integráció",
        title: "ÁFA-körös és alanyi adómentes vállalkozóknak is",
        description: "Mindegy, hogy ÁFA-körös vagy alanyi adómentes vagy — a rendszer mindkettőt kezeli. Kötsd be a Számlázz.hu fiókodat, és minden vásárláshoz automatikusan generálunk hivatalos magyar számlát.",
        bullets: [
          "Automatikus számla minden tranzakcióhoz",
          "ÁFA-körös és alanyi adómentes mód",
          "Számlázz.hu fiók egyszerű összekötése",
        ],
      },
    },
    setupOffer: {
      badge: "Opcionális extra · Egyszeri szolgáltatás",
      title: "Nem érsz rá beüzemelni? Mi megcsináljuk helyetted.",
      subtitle: "A Standard vagy Pro előfizetés mellé választható egyszeri szolgáltatás — nem havidíj, egyszer fizetsz és a csapatunk kulcsrakészen átadja a teljes rendszered.",
      price: "50.000 Ft",
      priceSuffix: "+ ÁFA · egyszeri",
      valueProp: "Első naptól működő rendszer, kulcsrakészen.",
      bullets: [
        "Felmérés és arculatra szabott weboldal",
        "Szolgáltatások, árak, fotók feltöltése",
        "Foglalási naptár, csapat, emlékeztetők beállítása",
        "Online fizetés, saját domain, automatikus számlázás",
        "10–15 induló social media poszt AI-val + SEO alapok",
        "1 órás személyes betanítás + 30 nap prioritásos támogatás",
      ],
      guarantee: "Elégedettségi garancia: 14 napon belül visszaadjuk a setup díjat, ha nem neked való.",
      ctaLabel: "Kérj visszahívást",
      footnote: "Egyszeri díj, a Standard vagy Pro előfizetés mellé választható.",
    },
    comparison: {
      title: "Egy előfizetés. Az összes eszköz, amire szükséged van.",
      subtitle: "A Bespire nem egy foglalási rendszer — egy teljes üzleti toolbox. Egyetlen helyen kapod meg azt, amire eddig 5-8 különböző szolgáltatást fizettél.",
      toolsTitle: "Mit vált ki a Bespire?",
      tools: [
        { icon: "Bot", name: "Magyar AI asszisztens", alt: "Nincs valódi alternatíva" },
        { icon: "FileText", name: "Teljes weboldal építő", alt: "Carrd, Leadpages helyett" },
        { icon: "Calendar", name: "Online időpontfoglaló", alt: "Calendly, SimplyBook helyett" },
        { icon: "CreditCard", name: "Online fizetés", alt: "Külön Stripe / Barion integráció helyett" },
        { icon: "Sparkles", name: "AI tartalom- és képgenerátor", alt: "ChatGPT Plus, Canva Pro helyett" },
        { icon: "Megaphone", name: "Social media menedzser", alt: "Buffer, Later, Meta Business helyett" },
        { icon: "Users", name: "Ügyfélkezelés / CRM", alt: "HubSpot, MiniCRM helyett" },
        { icon: "Bell", name: "Automatikus emlékeztetők", alt: "SMS és e-mail értesítő eszközök helyett" },
        { icon: "Mail", name: "E-mail marketing", alt: "Mailchimp, Brevo helyett" },
        { icon: "Repeat", name: "Előfizetések és bérletek", alt: "Külön tagsági és bérlet rendszerek helyett" },
        { icon: "Star", name: "Vélemények és értékelések", alt: "Trustpilot, Google Reviews kezelők helyett" },
        { icon: "MessageSquare", name: "Automatikus e-mail értesítések és visszajelzések kérése", alt: "Intercom, Tidio helyett" },
        { icon: "Package", name: "Digitális tartalom értékesítés", alt: "Külön webshop / Gumroad helyett" },
        { icon: "BarChart3", name: "Statisztikák és riportok", alt: "Google Analytics, külön dashboardok helyett" },
        { icon: "Image", name: "Galéria és képtár", alt: "Külön képmegosztó eszközök helyett" },
        { icon: "Video", name: "Személyes videóüzenetek", alt: "Külön videóüzenet szolgáltatások helyett" },
      ],
      summaryLabel: "Külön megvásárolva",
      summaryOthers: "~46 000 – 115 000 Ft / hó",
      summaryBespire: "12 900 Ft + ÁFA / hó",
      summaryBespireLabel: "Bespire-ben mindez (Növekedés csomag)",
      example: {
        badge: "Valós példa",
        title: "Egy átlagos felhasználó hónapja",
        personaName: "Anna – masszőr / kis stúdió",
        personaDetails: "1 helyszín · ~80 foglalás / hó · aktív social jelenlét + hírlevél",
        costsTitle: "Mennyit költött az adott hónapban?",
        costs: [
          { label: "Bespire Növekedés előfizetés", value: "12 900 Ft + ÁFA", tag: "AI a csomagban" },
          { label: "AI-asszisztens és AI-generálás", value: "0 Ft", tag: "csomagban" },
          { label: "Online fizetés jutalék", value: "csak ha online fizetnek (4% + 120 Ft / tranzakció)" },
        ],
        costsSummary: { label: "Összesen", value: "12 900 Ft + ÁFA" },

        creditsTitle: "Mit csinált meg ebben a hónapban?",
        credits: [
          { label: "80+ foglalás kezelése automatikusan (visszaigazolások, emlékeztetők)" },
          { label: "10 social media poszt megírása és képgenerálás" },
          { label: "Új landing oldal és weboldal szekciók létrehozása" },
          { label: "Termékleírások és akciós kampány szövegek" },
          { label: "Poszterek, story sablonok és design elemek" },
          { label: "Hírlevél kiküldése a teljes ügyféllistának" },
          { label: "Ügyféladatok és visszajelzések kezelése egy helyen" },
        ],
        creditsTotal: "Egy hónapnyi teljes üzletmenet — marketing, foglalás és ügyfélkezelés egy platformon.",
        savingsTitle: "Mit váltott ki ez az egy hónap?",
        savingsIntro: "Egy Bespire előfizetés helyettesíti a weboldal készítőt, foglalási rendszert, AI eszközöket, CRM-et, hírlevél küldőt és fizetési rendszert — mindezt egy helyen, egy árral.",
        savingsHighlight: "~40 000 – 130 000 Ft",
        savingsMoneyLabel: "megtakarítás havonta",
        savingsTimeHighlight: "Több óra",
        savingsTimeLabel: "megspórolva a napi adminisztrációból",
        savingsSubnote: "Nincs több külön számla, külön bejelentkezés és külön havidíj — minden egy felületen működik.",
      },
    },

    competitorTable: {
      title: "Bespire vs. külön weboldal + foglaló + általános AI",
      subtitle: "Mit kapsz egy Bespire előfizetéssel — és mit kellene összerakni külön eszközökből (weboldal-építő, foglalórendszer, ChatGPT / Gemini / Claude), hogy közelítsen ehhez.",
      columns: {
        feature: "Funkció",
        bespire: "Bespire",
        others: "Weboldal + foglaló + ChatGPT / Gemini / Claude",
      },
      rows: [
        { name: "Ismeri a szolgáltatásaidat, áraidat, ügyfeleidet", bespire: "Igen — a vállalkozásodra hangolva", others: "Nem — minden alkalommal újra el kell magyaráznod" },
        { name: "Magyar nyelvű, szolgáltatókra hangolt AI", bespire: true, others: "Általános magyar, gyakran fordításízű" },
        { name: "AI hozzáfér a foglalási naptáradhoz és ügyféladataidhoz", bespire: true, others: "Nem — külön rendszer, kézi másolás" },
        { name: "Weboldal generálás és szerkesztés AI-val", bespire: "Benne van", others: "Külön weboldal-építő + kézi átemelés" },
        { name: "Időpontfoglaló rendszer", bespire: true, others: "2–15 000 Ft / hó (külön eszköz)" },
        { name: "Automatikus ügyfélkommunikáció (emlékeztető, follow-up, hírlevél)", bespire: "A foglalások alapján automatikus", others: "Külön eszköz + kézi listakezelés" },
        { name: "AI tartalom (posztok, képek, hirdetés) a saját szolgáltatásaidra szabva", bespire: "Az adataid alapján", others: "Általános AI, minden brief kézzel" },
        { name: "Online fizetés, digitális termékek, bérletek", bespire: true, others: "Külön webshop / fizetési integráció" },
        { name: "Egy platform, egy előfizetés, egy support", bespire: true, others: "3–4 külön szolgáltató, külön számlák" },
        { name: "Magyar nyelvű support", bespire: true, others: "Általában csak angol" },
      ],
      partial: "Részben",
      totalLabel: "Összesen havonta",
      totalBespire: "12 900 Ft + ÁFA",
      totalOthers: "40–130 000 Ft / hó, több számlán (weboldal + foglaló + AI előfizetés)",
    },

    faqTitle: "Gyakori kérdések az árazásról",
    pricingFaq: [
      {
        q: "Melyik csomagot válasszam?",
        a: "A Növekedés (12 900 Ft + ÁFA / hó) tökéletes kezdésre és az egyéni szolgáltatóknak — AI-asszisztens a csomagban. A Prémium (24 900 Ft + ÁFA / hó) azoknak való, akik napi szinten intenzíven használják az AI-t. Bármikor válthatsz csomagot.",
      },
      {
        q: "Van keret vagy limit az AI-használatnál?",
        a: "Nincs külön AI-díj. Az AI-asszisztens és minden AI-generálás (szöveg, kép, weboldal) a csomagod része, napi használatra. Nincs kreditszámlálás, nincs meglepetés. Kampányidőszakban vagy extrém terhelésnél extra kapacitás igényelhető.",
      },
      {
        q: "Mit jelent a „normál üzleti használat”?",
        a: "Egy normál üzleti napi működést fedez le — a napi tartalomkészítéstől a kampányidőszakok intenzívebb generálásáig. Csak extrém, automatizált vagy nem üzleti célú terhelésnél jelzünk vissza. A valós vállalkozói használat a csomagod része — nincs külön korlát vagy díj.",
      },
      {
        q: "Mi történik a próbaidőszak alatt?",
        a: "3 napig teljes hozzáférést kapsz az összes funkcióhoz, beleértve az AI-asszisztens használatát is. Nem kell bankkártya, és bármikor lemondhatod.",
      },
      {
        q: "Van jutalék az értékesítéseimből?",
        a: "Helyszíni fizetésnél (kártya, készpénz, átutalás) 0% jutalék. Online fizetésnél a fizetési szolgáltatónak fizetendő 4% + 120 Ft / tranzakció — ezen a Bespire nem keres semmit.",
      },
      {
        q: "Mennyibe kerül a beüzemelés, ha nem magam csinálnám?",
        a: "50 000 Ft + ÁFA egyszeri díj, ami tartalmazza a teljes beállítást, tartalomfeltöltést, domain- és fizetésbekötést, valamint egy 1 órás személyes betanítást. Ezután az általad választott havidíj (Növekedés vagy Prémium) érvényes.",
      },
      {
        q: "Bármikor lemondhatom?",
        a: "Igen, kötelezettség nincs. Havidíjas előfizetés, bármikor lemondható a következő hónap előtt — nem számítunk fel kilépési díjat.",
      },
    ],
    finalCta: {
      title: "Készen állsz az indulásra?",
      subtitle: "Próbáld ki 3 napig ingyen, teljes hozzáféréssel, vagy kérj visszahívást és mi mindent beüzemelünk helyetted.",
      diyButton: "Indítsd el most – ingyen",
      setupButton: "Kérek visszahívást",
      footnote: "Bankkártya nem szükséges · 3 napos teljes hozzáférés · Bármikor lemondható",
    },
    backToLanding: "Vissza a főoldalra",
    detailedCtaLink: "Nézd meg a részletes árazást",

  },
  beforeAfterOnboarding: {
    badge: "Nem csak elindít — folyamatosan fejleszt",
    title: "Az onboarding csak a kezdet",
    subtitle: "A legtöbb eszköz felépíti a weboldalad és magadra hagy. A Bespire AI asszisztens az első naptól végig veled marad, és minden nap új dolgokon dolgozik.",
    before: {
      label: "Onboarding alatt",
      title: "Felépít mindent, ami az induláshoz kell",
      items: [
        "Arculat, pozicionálás, szolgáltatáscsomagok kialakítása",
        "Weboldal, foglalási rendszer, bérletek és fizetés",
        "Termékek, árazás, számlázás és admin beállítások",
        "Első marketing terv, personák, kulcsszavak, SEO alapok",
        "Ügyfélkommunikáció sablonok (email, üzenetek, emlékeztetők)",
      ],
    },
    after: {
      label: "Onboarding után",
      title: "Minden nap dolgozik veled, hogy sikeresebb legyél",
      items: [
        "Napi brief és teendőlista reggelente",
        "Új postok, kampányok, hirdetési tervek",
        "Régi ügyfelek visszahívása, email és üzenet kampányok",
        "Admin: számlák, kintlévőségek, havi riport AI kommentárral",
        "Új termékek, bérletek, bundle-ok, árazási javaslatok",
        "Proaktív ötletek: mit érdemes ma és ezen a héten csinálni",
      ],
    },
  },
  aiAssistantCapabilities: {
    badge: "Miben tud segíteni az AI asszisztens",
    title: "Egy asszisztens, ami tényleg mindenhez ért",
    subtitle: "Az onboarding végén nem tűnik el — folyamatosan tervez, ír, elemez és épít neked. Íme, miben segít nap mint nap:",
    groups: [
      {
        icon: "Palette",
        title: "Márka és stratégia",
        description: "Végigvisz az arculatod és üzleti terved teljes újragondolásán, ha kell, majd folyamatosan finomhangolja.",
        items: [
          "Arculat újratervezése",
          "Personák újragondolása",
          "Marketing terv újragondolása és folytatása",
          "Üzleti terv készítése, egyeztetése",
          "Névjegykártya tervezés",
          "Új versenytárs-elemzés",
        ],
      },
      {
        icon: "Globe",
        title: "Weboldal, tartalom, SEO",
        description: "Nem csak felépíti a weboldalad — utána is folyamatosan tölti tartalommal, optimalizálja és fordítja.",
        items: [
          "Új blogposztok",
          "Kulcsszó kitöltés",
          "SEO elemzés",
          "Új nyelv fordítása",
          "Médiatár és új képek generálása",
          "Új dokumentum készítése termékhez",
        ],
      },
      {
        icon: "Calendar",
        title: "Foglalás és naptár",
        description: "Online foglalás, csoportos órák, emlékeztetők, no-show követés — a naptárad magától megy.",
        items: [
          "Online foglalás az oldaladon",
          "Csoportos és 1:1 időpontok",
          "Automatikus visszaigazolás és emlékeztető",
          "Naptár-szinkron Google/Apple/Outlook felé",
          "No-show követés és várólista-kezelés",
        ],
      },
      {
        icon: "Megaphone",
        title: "Marketing és értékesítés",
        description: "Napi szintű social posztoktól a hirdetési kampányokig — az AI folyamatosan hozza az új ügyfeleket.",
        items: [
          "Új post és postterv",
          "Új hirdetési kampány és hirdetési terv",
          "Email kampányok indítása",
          "Régi ügyfelek aktivizálása",
          "Helyi partnerségek keresése",
        ],
      },
      {
        icon: "BarChart3",
        title: "Ügyfelek és elemzés",
        description: "Mélyen érti az ügyfeleidet és a számaidat — nem csak riportot ad, hanem konkrét javaslatokat is.",
        items: [
          "CRM funkcionalitás erősítése — vásárlói elemzések",
          "Mély teljesítmény-riport AI kommentárral",
          "Meetingre való felkészülés",
          "Új funkciók a user adminban",
        ],
      },
      {
        icon: "UserPlus",
        title: "Csapat és növekedés",
        description: "Amikor eljön az idő bővíteni, az AI végigvisz a teljes folyamaton — a hirdetéstől az interjú-kérdésekig.",
        items: [
          "Álláshirdetés megírása",
          "Interjú-kérdéssor",
          "HR marketing kampány",
        ],
      },
    ],
    footnote: "Csak mondd el chatben, mire van szükséged — az AI elkészíti, te pedig egy kattintással jóváhagyod.",
  },
  heroVibiz: {
    eyebrow: "AI asszisztens szolgáltatóknak",
    title: "Legyen neked is AI asszisztensed",
    subtitle: "A Bespire egy AI asszisztens, ami napról napra segít vinni a vállalkozásod — a brandtől az ügyfélkapcsolatokig, az adminisztrációtól a napi teendőkig. Válaszd ki, honnan indulsz.",
    tabs: {
      haveSite: "Van már weboldalam",
      fromIdea: "Ötletből indulok",
    },
    tabSubtitles: {
      haveSite: "Add meg a weboldalad címét — a Bespire megérti a vállalkozásod, és onnantól asszisztensként dolgozik neked: ír, foglal, számláz, mér, tervez.",
      fromIdea: "Írd le pár mondatban, mit csinálsz — a Bespire felépíti a hiányzó részeket, és attól kezdve napi AI asszisztensként vezet végig a működésen.",
    },
    placeholders: {
      haveSite: "pl. sajatweboldal.hu",
      fromIdea: "pl. Személyi edző vagyok Budapesten, kezdőknek",
    },
    submit: "Indítás",
    callbackPill: "Vagy foglalj egy 30 perces bemutatót",
    microcopy: "3 napig ingyen · bankkártya nem szükséges · magyar nyelvű támogatás",
  },
  ideaToRevenue: {
    title: "Ötlettől vagy URL‑től az élő bevételig",
    subtitle: "Nézd, ahogy a Bespire kihúzza a brandedet, felépíti az anyagokat, elindítja a kampányokat és bekapcsolja a fizetést. A vállalkozásod, autopilótán.",
  },
  howItWorks3: {
    title: "Hogyan működik",
    subtitle: "Három lépés. Akár most indulsz, akár skálázol.",
    steps: [
      {
        label: "01",
        title: "Add meg az URL‑t vagy az ötleted",
        description: "Illeszd be a jelenlegi oldalad, vagy írd le a vállalkozást amit szeretnél. A Bespire kihúzza a brandet, a célközönséget és az üzenetet.",
        chip: "sajatweboldal.hu",
      },
      {
        label: "02",
        title: "Felépítjük a teljes stacket",
        description: "Weboldal, foglalási naptár, szolgáltatások és bérletek, közösségi posztok, hirdetési kreatívok, email kampányok — legenerálva, nem sablonból.",
        chip: "+ AI asszisztens",
      },
      {
        label: "03",
        title: "Indulás és bevétel",
        description: "Ütemezzük a szerves posztokat, elindítjuk a fizetett hirdetéseket Meta, TikTok, Google felületeken, és a foglalás‑fizetés az első naptól él.",
        chip: "Élesben",
      },
    ],
  },
  businessMarquee: {
    title: "Szolgáltatókra szabva",
    subtitle: "Fitness, jóga, kozmetika és fodrászat, coaching, terápia, oktatás, kivitelezés és kertészet. Minden szakma, saját hangon.",
    hint: "Kattints a szakmádra",
    alts: [
      "Fitness edző munka közben",
      "Jóga óra",
      "Kozmetikus szalon",
      "Masszázs kezelés",
      "Fodrász szalon",
      "Körmös műhely",
      "Kivitelező szakember munka közben",
      "Fotós stúdió",
      "Coach ügyféllel",
      "Pszichológus rendelő",
      "Táplálkozási tanácsadás",
      "Sportklub belső",
      "Terapeuta gyerekkel",
      "Kertészet és kertépítés",
    ],
  },
  studios: {
    title: "Célra épített stúdiók",
    subtitle: "Mélyre menő eszközök a Bespire‑en belül — mindegyik saját munkafolyamattal.",
    items: [
      {
        badge: "Website Studio",
        title: "Egy prompt — kész weboldal a brandeddel",
        description: "Add meg az ötleted vagy a jelenlegi URL‑t, és percek alatt kapsz élesíthető oldalt — nem sablonból, hanem a te szolgáltatásaidra szabva.",
        cta: "Website Studio",
        href: "/website-builder",
      },
      {
        badge: "Booking Studio",
        title: "Foglalás, bérletek és fizetés egyben",
        description: "Online naptár, csoportos és 1:1 időpontok, bérletek, előleg, automata emlékeztetők — kliensednek nem kell semmit letöltenie.",
        cta: "Booking Studio",
        href: "/booking-system",
      },
      {
        badge: "Marketing Studio",
        title: "Social posztok és hirdetések autopilótán",
        description: "Havi terv, poszt‑ütemezés Instagramra, Facebookra és TikTokra, és AI‑generált hirdetési kreatívok — mindig a brandedhez illeszkedve.",
        cta: "Marketing Studio",
        href: "/marketing-automation",
      },
    ],
  },
  wallOfLove: {
    title: "Amit az ügyfeleink mondanak",
    subtitle: "Szolgáltatók, akik már a Bespire‑rel dolgoznak.",
    rating: "4.9/5",
    ratingSuffix: "korai felhasználóktól",
    quotes: [
      { name: "Cili", role: "Gonda‑Geszler mozgásterapeuta", quote: "10 perc alatt használható üzleti eszközök voltak a kezemben: saját oldal, foglalási naptár és az első marketingterv — nem kell külön eszközöket összefércelni." },
      { name: "Anna", role: "Kozmetikus, Budapest", quote: "Az AI megírja a heti posztokat és a hirdetéseket is — én csak jóváhagyom. Több szabad időm van a szalonban." },
      { name: "Péter", role: "Personal trainer", quote: "Az edzésbérlet, a fizetés és a naptár egy helyen. Az ügyfeleknek nem kell app, csak lefoglalják és jönnek." },
      { name: "Réka", role: "Jógaoktató", quote: "Az egész órarend és a heti hírlevél magától megy. Végre a jógára tudok fókuszálni." },
      { name: "Márk", role: "Business coach", quote: "Az AI segített a pozicionálásban és megírta az első hideg kampányt is. Két hét alatt lett három új ügyfelem." },
      { name: "Zsófi", role: "Fodrász, Debrecen", quote: "A fotókból profi Instagram poszt lesz kattintásra. Az ügyfelek is szólnak, hogy szép lett az oldal." },
      { name: "Bence", role: "Táplálkozási tanácsadó", quote: "A csomagjaim és a foglalás egy helyen. Az AI még blogposztot is ír a témáimhoz." },
      { name: "Nóra", role: "Pszichológus", quote: "Diszkrét, letisztult megjelenés és biztonságos foglalás — pont ami a szakmámhoz kellett." },
      { name: "Gábor", role: "Sportklub tulajdonos", quote: "Csoportos órák, bérletek, marketing — végre minden egy helyen és nem három programban." },
      { name: "Kata", role: "Masszőr, Szeged", quote: "Az emlékeztetőket az AI intézi, a lemondások aránya harmadára csökkent. Végre látom, ki jön és ki maradt el." },
      { name: "Dóri", role: "Körömszakértő", quote: "A visszatérő ügyfeleket a rendszer figyeli — ha valaki két hónapja nem járt, kapok egy javaslatot. Csak jóváhagyom." },
      { name: "Tamás", role: "Fizioterapeuta", quote: "A számlázás és a heti riport magától készül. A könyvelőmnek csak továbbküldöm — nem excelezek többet." },
    ],
  },
  assistantCrossLinks: {
    badge: "Az AI asszisztens további képességei",
    title: "Fedezd fel, mi mindenben segít még a Bespire",
    subtitle: "Egy platform, három erős munkafolyamat — mind ugyanaz az AI asszisztens hajtja.",
    items: {
      websiteBuilder: {
        title: "Weboldal AI-val",
        description: "Percek alatt kész, egyedi weboldal a brandeddel — chatben szerkeszthető, saját domainre publikálható.",
        cta: "Weboldal építő megnyitása",
      },
      bookingSystem: {
        title: "Foglalási rendszer",
        description: "Online naptár, csoportos és 1:1 időpontok, bérletek, előleg, WhatsApp emlékeztetők. Az ügyfélnek nem kell app.",
        cta: "Foglalási rendszer megnyitása",
      },
      marketingAutomation: {
        title: "Marketing automatizáció",
        description: "AI generálja és ütemezi a posztokat Instagramra, Facebookra, TikTokra. Hirdetési kreatívok és email kampányok is.",
        cta: "Marketing automatizáció megnyitása",
      },
    },
    viewAll: "Nézd meg az összes AI funkciót",
  },
};
